const geoNamesList = [
  {
    continent: "EU",
    capital: "Andorra la Vella",
    languages: "ca",
    geonameId: 3041565,
    south: 42.4287475,
    isoAlpha3: "AND",
    north: 42.655887500000006,
    fipsCode: "AN",
    population: "77006",
    east: 1.7866939,
    isoNumeric: "020",
    areaInSqKm: "468.0",
    countryCode: "AD",
    west: 1.4135734,
    countryName: "Andorra",
    postalCodeFormat: "AD###",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AS",
    capital: "Abu Dhabi",
    languages: "ar-AE,fa,en,hi,ur",
    geonameId: 290557,
    south: 22.6315119400001,
    isoAlpha3: "ARE",
    north: 26.0693916590001,
    fipsCode: "AE",
    population: "9630959",
    east: 56.381222289,
    isoNumeric: "784",
    areaInSqKm: "82880.0",
    countryCode: "AE",
    west: 51.5904085340001,
    countryName: "United Arab Emirates",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "AED",
  },
  {
    continent: "AS",
    capital: "Kabul",
    languages: "fa-AF,ps,uz-AF,tk",
    geonameId: 1149361,
    south: 29.3770645357176,
    isoAlpha3: "AFG",
    north: 38.4907920755748,
    fipsCode: "AF",
    population: "37172386",
    east: 74.8894511481168,
    isoNumeric: "004",
    areaInSqKm: "647500.0",
    countryCode: "AF",
    west: 60.4720833972263,
    countryName: "Afghanistan",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "AFN",
  },
  {
    continent: "NA",
    capital: "St John's",
    languages: "en-AG",
    geonameId: 3576396,
    south: 16.997852913000003,
    isoAlpha3: "ATG",
    north: 17.729482678,
    fipsCode: "AC",
    population: "96286",
    east: -61.673633812000006,
    isoNumeric: "028",
    areaInSqKm: "443.0",
    countryCode: "AG",
    west: -61.906386729000005,
    countryName: "Antigua and Barbuda",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "NA",
    capital: "The Valley",
    languages: "en-AI",
    geonameId: 3573511,
    south: 18.15961884,
    isoAlpha3: "AIA",
    north: 18.276289043000002,
    fipsCode: "AV",
    population: "13254",
    east: -62.965782689,
    isoNumeric: "660",
    areaInSqKm: "102.0",
    countryCode: "AI",
    west: -63.172970186,
    countryName: "Anguilla",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "EU",
    capital: "Tirana",
    languages: "sq,el",
    geonameId: 783754,
    south: 39.6448624829142,
    isoAlpha3: "ALB",
    north: 42.6611669383269,
    fipsCode: "AL",
    population: "2866376",
    east: 21.0574334835312,
    isoNumeric: "008",
    areaInSqKm: "28748.0",
    countryCode: "AL",
    west: 19.2639112711741,
    countryName: "Albania",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "ALL",
  },
  {
    continent: "AS",
    capital: "Yerevan",
    languages: "hy",
    geonameId: 174982,
    south: 38.840244,
    isoAlpha3: "ARM",
    north: 41.3009930000001,
    fipsCode: "AM",
    population: "2951776",
    east: 46.6342220000001,
    isoNumeric: "051",
    areaInSqKm: "29800.0",
    countryCode: "AM",
    west: 43.447417525,
    countryName: "Armenia",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "AMD",
  },
  {
    continent: "AF",
    capital: "Luanda",
    languages: "pt-AO",
    geonameId: 3351879,
    south: -18.039104000000002,
    isoAlpha3: "AGO",
    north: -4.3880634,
    fipsCode: "AO",
    population: "30809762",
    east: 24.0878856,
    isoNumeric: "024",
    areaInSqKm: "1246700.0",
    countryCode: "AO",
    west: 11.670196277,
    countryName: "Angola",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "AOA",
  },
  {
    continent: "AN",
    capital: "",
    languages: "",
    geonameId: 6697173,
    south: -89.9999,
    isoAlpha3: "ATA",
    north: -60.515533,
    fipsCode: "AY",
    population: "0",
    east: 179.9999,
    isoNumeric: "010",
    areaInSqKm: "1.4E7",
    countryCode: "AQ",
    west: -179.9999,
    countryName: "Antarctica",
    postalCodeFormat: "",
    continentName: "Antarctica",
    currencyCode: "",
  },
  {
    continent: "SA",
    capital: "Buenos Aires",
    languages: "es-AR,en,it,de,fr,gn",
    geonameId: 3865483,
    south: -55.0576984539999,
    isoAlpha3: "ARG",
    north: -21.777951173,
    fipsCode: "AR",
    population: "44494502",
    east: -53.637962552,
    isoNumeric: "032",
    areaInSqKm: "2766890.0",
    countryCode: "AR",
    west: -73.566302817,
    countryName: "Argentina",
    postalCodeFormat: "@####@@@",
    continentName: "South America",
    currencyCode: "ARS",
  },
  {
    continent: "OC",
    capital: "Pago Pago",
    languages: "en-AS,sm,to",
    geonameId: 5880801,
    south: -14.373776,
    isoAlpha3: "ASM",
    north: -11.047857,
    fipsCode: "AQ",
    population: "55465",
    east: -169.418925,
    isoNumeric: "016",
    areaInSqKm: "199.0",
    countryCode: "AS",
    west: -171.090042,
    countryName: "American Samoa",
    postalCodeFormat: "#####-####",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "EU",
    capital: "Vienna",
    languages: "de-AT,hr,hu,sl",
    geonameId: 2782113,
    south: 46.3726520216244,
    isoAlpha3: "AUT",
    north: 49.0211627691393,
    fipsCode: "AU",
    population: "8847037",
    east: 17.1620685652599,
    isoNumeric: "040",
    areaInSqKm: "83858.0",
    countryCode: "AT",
    west: 9.53095237240833,
    countryName: "Austria",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "OC",
    capital: "Canberra",
    languages: "en-AU",
    geonameId: 2077456,
    south: -43.643194904,
    isoAlpha3: "AUS",
    north: -10.059130975,
    fipsCode: "AS",
    population: "24992369",
    east: 153.638727019,
    isoNumeric: "036",
    areaInSqKm: "7686850.0",
    countryCode: "AU",
    west: 112.921113949,
    countryName: "Australia",
    postalCodeFormat: "####",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "NA",
    capital: "Oranjestad",
    languages: "nl-AW,pap,es,en",
    geonameId: 3577279,
    south: 12.412106778,
    isoAlpha3: "ABW",
    north: 12.623131233,
    fipsCode: "AA",
    population: "105845",
    east: -69.866001173,
    isoNumeric: "533",
    areaInSqKm: "193.0",
    countryCode: "AW",
    west: -70.06347981500001,
    countryName: "Aruba",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "AWG",
  },
  {
    continent: "EU",
    capital: "Mariehamn",
    languages: "sv-AX",
    geonameId: 661882,
    south: 59.90135939300001,
    isoAlpha3: "ALA",
    north: 60.49399356200001,
    fipsCode: "",
    population: "26711",
    east: 21.021359934000003,
    isoNumeric: "248",
    areaInSqKm: "1580.0",
    countryCode: "AX",
    west: 19.310969323000002,
    countryName: "Åland",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AS",
    capital: "Baku",
    languages: "az,ru,hy",
    geonameId: 587116,
    south: 38.3922170010001,
    isoAlpha3: "AZE",
    north: 41.9123400010001,
    fipsCode: "AJ",
    population: "9942334",
    east: 50.3700828550001,
    isoNumeric: "031",
    areaInSqKm: "86600.0",
    countryCode: "AZ",
    west: 44.764683001,
    countryName: "Azerbaijan",
    postalCodeFormat: "AZ ####",
    continentName: "Asia",
    currencyCode: "AZN",
  },
  {
    continent: "EU",
    capital: "Sarajevo",
    languages: "bs,hr-BA,sr-BA",
    geonameId: 3277605,
    south: 42.555473846,
    isoAlpha3: "BIH",
    north: 45.276539649,
    fipsCode: "BK",
    population: "3323929",
    east: 19.6237016800001,
    isoNumeric: "070",
    areaInSqKm: "51129.0",
    countryCode: "BA",
    west: 15.728732108,
    countryName: "Bosnia and Herzegovina",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "BAM",
  },
  {
    continent: "NA",
    capital: "Bridgetown",
    languages: "en-BB",
    geonameId: 3374084,
    south: 13.044896628,
    isoAlpha3: "BRB",
    north: 13.335128143,
    fipsCode: "BB",
    population: "286641",
    east: -59.420396444000005,
    isoNumeric: "052",
    areaInSqKm: "431.0",
    countryCode: "BB",
    west: -59.651011138,
    countryName: "Barbados",
    postalCodeFormat: "BB#####",
    continentName: "North America",
    currencyCode: "BBD",
  },
  {
    continent: "AS",
    capital: "Dhaka",
    languages: "bn-BD,en",
    geonameId: 1210997,
    south: 21.719218206,
    isoAlpha3: "BGD",
    north: 23.526564698,
    fipsCode: "BG",
    population: "161356039",
    east: 91.896540435,
    isoNumeric: "050",
    areaInSqKm: "144000.0",
    countryCode: "BD",
    west: 89.032430407,
    countryName: "Bangladesh",
    postalCodeFormat: "####",
    continentName: "Asia",
    currencyCode: "BDT",
  },
  {
    continent: "EU",
    capital: "Brussels",
    languages: "nl-BE,fr-BE,de-BE",
    geonameId: 2802361,
    south: 49.496968483036,
    isoAlpha3: "BEL",
    north: 51.5051118897455,
    fipsCode: "BE",
    population: "11422068",
    east: 6.40793743953125,
    isoNumeric: "056",
    areaInSqKm: "30510.0",
    countryCode: "BE",
    west: 2.54132898439873,
    countryName: "Belgium",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Ouagadougou",
    languages: "fr-BF,mos",
    geonameId: 2361809,
    south: 9.41047177500008,
    isoAlpha3: "BFA",
    north: 15.084033447,
    fipsCode: "UV",
    population: "19751535",
    east: 2.40435976900005,
    isoNumeric: "854",
    areaInSqKm: "274200.0",
    countryCode: "BF",
    west: -5.51324157299996,
    countryName: "Burkina Faso",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "EU",
    capital: "Sofia",
    languages: "bg,tr-BG,rom",
    geonameId: 732800,
    south: 41.235341500000004,
    isoAlpha3: "BGR",
    north: 44.2154806,
    fipsCode: "BU",
    population: "7000039",
    east: 28.607429551000003,
    isoNumeric: "100",
    areaInSqKm: "110910.0",
    countryCode: "BG",
    west: 22.357156800000002,
    countryName: "Bulgaria",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "BGN",
  },
  {
    continent: "AS",
    capital: "Manama",
    languages: "ar-BH,en,fa,ur",
    geonameId: 290291,
    south: 25.790910001,
    isoAlpha3: "BHR",
    north: 26.3308150010001,
    fipsCode: "BA",
    population: "1569439",
    east: 50.720622,
    isoNumeric: "048",
    areaInSqKm: "665.0",
    countryCode: "BH",
    west: 50.3158550000001,
    countryName: "Bahrain",
    postalCodeFormat: "####|###",
    continentName: "Asia",
    currencyCode: "BHD",
  },
  {
    continent: "AF",
    capital: "Gitega",
    languages: "fr-BI,rn",
    geonameId: 433561,
    south: -4.46932899899997,
    isoAlpha3: "BDI",
    north: -2.30973016299993,
    fipsCode: "BY",
    population: "11175378",
    east: 30.84954,
    isoNumeric: "108",
    areaInSqKm: "27830.0",
    countryCode: "BI",
    west: 29.0009680000001,
    countryName: "Burundi",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "BIF",
  },
  {
    continent: "AF",
    capital: "Porto-Novo",
    languages: "fr-BJ",
    geonameId: 2395170,
    south: 6.23477794100006,
    isoAlpha3: "BEN",
    north: 12.4086110000001,
    fipsCode: "BN",
    population: "11485048",
    east: 3.84306303800003,
    isoNumeric: "204",
    areaInSqKm: "112620.0",
    countryCode: "BJ",
    west: 0.775412326000037,
    countryName: "Benin",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "NA",
    capital: "Gustavia",
    languages: "fr",
    geonameId: 3578476,
    south: 17.878183227405575,
    isoAlpha3: "BLM",
    north: 17.928808791949283,
    fipsCode: "TB",
    population: "8450",
    east: -62.788983372985854,
    isoNumeric: "652",
    areaInSqKm: "21.0",
    countryCode: "BL",
    west: -62.8739118253784,
    countryName: "Saint Barthélemy",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "EUR",
  },
  {
    continent: "NA",
    capital: "Hamilton",
    languages: "en-BM,pt",
    geonameId: 3573345,
    south: 32.247240870129,
    isoAlpha3: "BMU",
    north: 32.3909785046382,
    fipsCode: "BD",
    population: "63968",
    east: -64.6473267161152,
    isoNumeric: "060",
    areaInSqKm: "53.0",
    countryCode: "BM",
    west: -64.8870418687384,
    countryName: "Bermuda",
    postalCodeFormat: "@@ ##",
    continentName: "North America",
    currencyCode: "BMD",
  },
  {
    continent: "AS",
    capital: "Bandar Seri Begawan",
    languages: "ms-BN,en-BN",
    geonameId: 1820814,
    south: 4.00264384400003,
    isoAlpha3: "BRN",
    north: 5.04571171901151,
    fipsCode: "BX",
    population: "428962",
    east: 115.364671704,
    isoNumeric: "096",
    areaInSqKm: "5770.0",
    countryCode: "BN",
    west: 114.075926291,
    countryName: "Brunei",
    postalCodeFormat: "@@####",
    continentName: "Asia",
    currencyCode: "BND",
  },
  {
    continent: "SA",
    capital: "Sucre",
    languages: "es-BO,qu,ay",
    geonameId: 3923057,
    south: -22.89809,
    isoAlpha3: "BOL",
    north: -9.66932299899997,
    fipsCode: "BL",
    population: "11353142",
    east: -57.4538029999999,
    isoNumeric: "068",
    areaInSqKm: "1098580.0",
    countryCode: "BO",
    west: -69.644939573,
    countryName: "Bolivia",
    postalCodeFormat: "",
    continentName: "South America",
    currencyCode: "BOB",
  },
  {
    continent: "NA",
    capital: "Kralendijk",
    languages: "nl,pap,en",
    geonameId: 7626844,
    south: 12.025647971000001,
    isoAlpha3: "BES",
    north: 12.311868424,
    fipsCode: "",
    population: "18012",
    east: -68.195332674,
    isoNumeric: "535",
    areaInSqKm: "328.0",
    countryCode: "BQ",
    west: -68.421178846,
    countryName: "Bonaire, Sint Eustatius, and Saba",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "SA",
    capital: "Brasília",
    languages: "pt-BR,es,en,fr",
    geonameId: 3469034,
    south: -32.655733109,
    isoAlpha3: "BRA",
    north: 5.2717863,
    fipsCode: "BR",
    population: "209469333",
    east: -32.391076267,
    isoNumeric: "076",
    areaInSqKm: "8511965.0",
    countryCode: "BR",
    west: -73.98281700000001,
    countryName: "Brazil",
    postalCodeFormat: "#####-###",
    continentName: "South America",
    currencyCode: "BRL",
  },
  {
    continent: "NA",
    capital: "Nassau",
    languages: "en-BS",
    geonameId: 3572887,
    south: 22.852743,
    isoAlpha3: "BHS",
    north: 26.919243,
    fipsCode: "BF",
    population: "385640",
    east: -74.423874,
    isoNumeric: "044",
    areaInSqKm: "13940.0",
    countryCode: "BS",
    west: -78.999528159018,
    countryName: "Bahamas",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "BSD",
  },
  {
    continent: "AS",
    capital: "Thimphu",
    languages: "dz",
    geonameId: 1252634,
    south: 26.702020985,
    isoAlpha3: "BTN",
    north: 28.246987001,
    fipsCode: "BT",
    population: "754394",
    east: 92.12523192,
    isoNumeric: "064",
    areaInSqKm: "47000.0",
    countryCode: "BT",
    west: 88.7455215570001,
    countryName: "Bhutan",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "BTN",
  },
  {
    continent: "AN",
    capital: "",
    languages: "",
    geonameId: 3371123,
    south: -54.452306883000006,
    isoAlpha3: "BVT",
    north: -54.38673682300001,
    fipsCode: "BV",
    population: "0",
    east: 3.43339585,
    isoNumeric: "074",
    areaInSqKm: "49.0",
    countryCode: "BV",
    west: 3.286359958,
    countryName: "Bouvet Island",
    postalCodeFormat: "",
    continentName: "Antarctica",
    currencyCode: "NOK",
  },
  {
    continent: "AF",
    capital: "Gaborone",
    languages: "en-BW,tn-BW",
    geonameId: 933860,
    south: -26.907545,
    isoAlpha3: "BWA",
    north: -17.778136999,
    fipsCode: "BC",
    population: "2254126",
    east: 29.375304,
    isoNumeric: "072",
    areaInSqKm: "600370.0",
    countryCode: "BW",
    west: 19.998903,
    countryName: "Botswana",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "BWP",
  },
  {
    continent: "EU",
    capital: "Minsk",
    languages: "be,ru",
    geonameId: 630336,
    south: 51.262011,
    isoAlpha3: "BLR",
    north: 56.1724940010001,
    fipsCode: "BO",
    population: "9485386",
    east: 32.776820001,
    isoNumeric: "112",
    areaInSqKm: "207600.0",
    countryCode: "BY",
    west: 23.1781980010001,
    countryName: "Belarus",
    postalCodeFormat: "######",
    continentName: "Europe",
    currencyCode: "BYN",
  },
  {
    continent: "NA",
    capital: "Belmopan",
    languages: "en-BZ,es",
    geonameId: 3582678,
    south: 15.885619,
    isoAlpha3: "BLZ",
    north: 18.495942,
    fipsCode: "BH",
    population: "383071",
    east: -87.76179484000001,
    isoNumeric: "084",
    areaInSqKm: "22966.0",
    countryCode: "BZ",
    west: -89.22758800000001,
    countryName: "Belize",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "BZD",
  },
  {
    continent: "NA",
    capital: "Ottawa",
    languages: "en-CA,fr-CA,iu",
    geonameId: 6251999,
    south: 41.6765678,
    isoAlpha3: "CAN",
    north: 83.113214493,
    fipsCode: "CA",
    population: "37058856",
    east: -52.619079929,
    isoNumeric: "124",
    areaInSqKm: "9984670.0",
    countryCode: "CA",
    west: -141.0018584,
    countryName: "Canada",
    postalCodeFormat: "@#@ #@#",
    continentName: "North America",
    currencyCode: "CAD",
  },
  {
    continent: "AS",
    capital: "West Island",
    languages: "ms-CC,en",
    geonameId: 1547376,
    south: -12.208725839,
    isoAlpha3: "CCK",
    north: -12.072459094,
    fipsCode: "CK",
    population: "628",
    east: 96.929489344,
    isoNumeric: "166",
    areaInSqKm: "14.0",
    countryCode: "CC",
    west: 96.816941408,
    countryName: "Cocos (Keeling) Islands",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "AUD",
  },
  {
    continent: "AF",
    capital: "Kinshasa",
    languages: "fr-CD,ln,ktu,kg,sw,lua",
    geonameId: 203312,
    south: -13.459034999,
    isoAlpha3: "COD",
    north: 5.39200300000005,
    fipsCode: "CG",
    population: "84068091",
    east: 31.3146120000001,
    isoNumeric: "180",
    areaInSqKm: "2345410.0",
    countryCode: "CD",
    west: 12.202361491,
    countryName: "DR Congo",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "CDF",
  },
  {
    continent: "AF",
    capital: "Bangui",
    languages: "fr-CF,sg,ln,kg",
    geonameId: 239880,
    south: 2.22305300000005,
    isoAlpha3: "CAF",
    north: 11.017957,
    fipsCode: "CT",
    population: "4666377",
    east: 27.4583050000001,
    isoNumeric: "140",
    areaInSqKm: "622984.0",
    countryCode: "CF",
    west: 14.4150980000001,
    countryName: "Central African Republic",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "AF",
    capital: "Brazzaville",
    languages: "fr-CG,kg,ln-CG",
    geonameId: 2260494,
    south: -5.04072158799994,
    isoAlpha3: "COG",
    north: 3.70779100000004,
    fipsCode: "CF",
    population: "5244363",
    east: 18.65042119,
    isoNumeric: "178",
    areaInSqKm: "342000.0",
    countryCode: "CG",
    west: 11.1520760600001,
    countryName: "Congo Republic",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "EU",
    capital: "Bern",
    languages: "de-CH,fr-CH,it-CH,rm",
    geonameId: 2658434,
    south: 45.8191539516188,
    isoAlpha3: "CHE",
    north: 47.8098679329775,
    fipsCode: "SZ",
    population: "8516543",
    east: 10.4934735095497,
    isoNumeric: "756",
    areaInSqKm: "41290.0",
    countryCode: "CH",
    west: 5.95661377423453,
    countryName: "Switzerland",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "CHF",
  },
  {
    continent: "AF",
    capital: "Yamoussoukro",
    languages: "fr-CI",
    geonameId: 2287781,
    south: 4.36035248000007,
    isoAlpha3: "CIV",
    north: 10.740015,
    fipsCode: "IV",
    population: "25069229",
    east: -2.49303099999997,
    isoNumeric: "384",
    areaInSqKm: "322460.0",
    countryCode: "CI",
    west: -8.60205899999994,
    countryName: "Ivory Coast",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "OC",
    capital: "Avarua",
    languages: "en-CK,mi",
    geonameId: 1899402,
    south: -21.958539727,
    isoAlpha3: "COK",
    north: -10.024169,
    fipsCode: "CW",
    population: "21388",
    east: -157.32204534500002,
    isoNumeric: "184",
    areaInSqKm: "240.0",
    countryCode: "CK",
    west: -161.105922999,
    countryName: "Cook Islands",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "NZD",
  },
  {
    continent: "SA",
    capital: "Santiago",
    languages: "es-CL",
    geonameId: 3895114,
    south: -55.909795409,
    isoAlpha3: "CHL",
    north: -17.4977759459999,
    fipsCode: "CI",
    population: "18729160",
    east: -66.416152278,
    isoNumeric: "152",
    areaInSqKm: "756950.0",
    countryCode: "CL",
    west: -80.8370287079999,
    countryName: "Chile",
    postalCodeFormat: "#######",
    continentName: "South America",
    currencyCode: "CLP",
  },
  {
    continent: "AF",
    capital: "Yaoundé",
    languages: "en-CM,fr-CM",
    geonameId: 2233387,
    south: 1.65590000000003,
    isoAlpha3: "CMR",
    north: 13.083334,
    fipsCode: "CM",
    population: "25216237",
    east: 16.1944080000001,
    isoNumeric: "120",
    areaInSqKm: "475440.0",
    countryCode: "CM",
    west: 8.49843402900007,
    countryName: "Cameroon",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "AS",
    capital: "Beijing",
    languages: "zh-CN,yue,wuu,dta,ug,za",
    geonameId: 1814991,
    south: 15.775416,
    isoAlpha3: "CHN",
    north: 53.560974001,
    fipsCode: "CH",
    population: "1411778724",
    east: 134.7754563,
    isoNumeric: "156",
    areaInSqKm: "9596960.0",
    countryCode: "CN",
    west: 73.4994140000001,
    countryName: "China",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "CNY",
  },
  {
    continent: "SA",
    capital: "Bogotá",
    languages: "es-CO",
    geonameId: 3686110,
    south: -4.22839224299997,
    isoAlpha3: "COL",
    north: 13.38600323,
    fipsCode: "CO",
    population: "49648685",
    east: -66.8472153989999,
    isoNumeric: "170",
    areaInSqKm: "1138910.0",
    countryCode: "CO",
    west: -81.735775648,
    countryName: "Colombia",
    postalCodeFormat: "######",
    continentName: "South America",
    currencyCode: "COP",
  },
  {
    continent: "NA",
    capital: "San José",
    languages: "es-CR,en",
    geonameId: 3624060,
    south: 8.03962731803416,
    isoAlpha3: "CRI",
    north: 11.2197589122308,
    fipsCode: "CS",
    population: "4999441",
    east: -82.552318987959,
    isoNumeric: "188",
    areaInSqKm: "51100.0",
    countryCode: "CR",
    west: -85.9502523586265,
    countryName: "Costa Rica",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "CRC",
  },
  {
    continent: "NA",
    capital: "Havana",
    languages: "es-CU,pap",
    geonameId: 3562981,
    south: 19.826172913,
    isoAlpha3: "CUB",
    north: 23.205106375,
    fipsCode: "CU",
    population: "11338138",
    east: -74.131757291,
    isoNumeric: "192",
    areaInSqKm: "110860.0",
    countryCode: "CU",
    west: -84.952245207,
    countryName: "Cuba",
    postalCodeFormat: "CP #####",
    continentName: "North America",
    currencyCode: "CUP",
  },
  {
    continent: "AF",
    capital: "Praia",
    languages: "pt-CV",
    geonameId: 3374766,
    south: 14.812322458,
    isoAlpha3: "CPV",
    north: 17.206296667,
    fipsCode: "CV",
    population: "543767",
    east: -22.664677706000003,
    isoNumeric: "132",
    areaInSqKm: "4033.0",
    countryCode: "CV",
    west: -25.361204280000003,
    countryName: "Cabo Verde",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "CVE",
  },
  {
    continent: "NA",
    capital: "Willemstad",
    languages: "nl,pap",
    geonameId: 7626836,
    south: 12.034003977000001,
    isoAlpha3: "CUW",
    north: 12.392445451,
    fipsCode: "UC",
    population: "159849",
    east: -68.736739869,
    isoNumeric: "531",
    areaInSqKm: "444.0",
    countryCode: "CW",
    west: -69.162557726,
    countryName: "Curaçao",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "ANG",
  },
  {
    continent: "OC",
    capital: "Flying Fish Cove",
    languages: "en,zh,ms-CX",
    geonameId: 2078138,
    south: -10.5704829995,
    isoAlpha3: "CXR",
    north: -10.412356007,
    fipsCode: "KT",
    population: "1500",
    east: 105.712596992,
    isoNumeric: "162",
    areaInSqKm: "135.0",
    countryCode: "CX",
    west: 105.533276992,
    countryName: "Christmas Island",
    postalCodeFormat: "####",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "EU",
    capital: "Nicosia",
    languages: "el-CY,tr-CY,en",
    geonameId: 146669,
    south: 34.632303001,
    isoAlpha3: "CYP",
    north: 35.69493443939431,
    fipsCode: "CY",
    population: "1189265",
    east: 34.5877096808548,
    isoNumeric: "196",
    areaInSqKm: "9250.0",
    countryCode: "CY",
    west: 32.271016385336786,
    countryName: "Cyprus",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Prague",
    languages: "cs,sk",
    geonameId: 3077311,
    south: 48.551892864201,
    isoAlpha3: "CZE",
    north: 51.0557782422661,
    fipsCode: "EZ",
    population: "10625695",
    east: 18.8592743799298,
    isoNumeric: "203",
    areaInSqKm: "78866.0",
    countryCode: "CZ",
    west: 12.0906691601139,
    countryName: "Czechia",
    postalCodeFormat: "### ##",
    continentName: "Europe",
    currencyCode: "CZK",
  },
  {
    continent: "EU",
    capital: "Berlin",
    languages: "de",
    geonameId: 2921044,
    south: 47.2701236047002,
    isoAlpha3: "DEU",
    north: 55.0583836008072,
    fipsCode: "GM",
    population: "82927922",
    east: 15.0418156516163,
    isoNumeric: "276",
    areaInSqKm: "357021.0",
    countryCode: "DE",
    west: 5.8663152683722,
    countryName: "Germany",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Djibouti",
    languages: "fr-DJ,ar,so-DJ,aa",
    geonameId: 223816,
    south: 10.9129530000001,
    isoAlpha3: "DJI",
    north: 12.7136967920001,
    fipsCode: "DJ",
    population: "958920",
    east: 43.4175099920001,
    isoNumeric: "262",
    areaInSqKm: "23000.0",
    countryCode: "DJ",
    west: 41.7708460000001,
    countryName: "Djibouti",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "DJF",
  },
  {
    continent: "EU",
    capital: "Copenhagen",
    languages: "da-DK,en,fo,de-DK",
    geonameId: 2623032,
    south: 54.5590783718363,
    isoAlpha3: "DNK",
    north: 57.3282078631757,
    fipsCode: "DA",
    population: "5797446",
    east: 15.1569721573943,
    isoNumeric: "208",
    areaInSqKm: "43094.0",
    countryCode: "DK",
    west: 8.07250975308422,
    countryName: "Denmark",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "DKK",
  },
  {
    continent: "NA",
    capital: "Roseau",
    languages: "en-DM",
    geonameId: 3575830,
    south: 15.207302633000001,
    isoAlpha3: "DMA",
    north: 15.639513083,
    fipsCode: "DO",
    population: "71625",
    east: -61.240777722000004,
    isoNumeric: "212",
    areaInSqKm: "754.0",
    countryCode: "DM",
    west: -61.480074771000005,
    countryName: "Dominica",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "NA",
    capital: "Santo Domingo",
    languages: "es-DO",
    geonameId: 3508796,
    south: 17.5395066830409,
    isoAlpha3: "DOM",
    north: 19.9321257501267,
    fipsCode: "DR",
    population: "10627165",
    east: -68.3229591969468,
    isoNumeric: "214",
    areaInSqKm: "48730.0",
    countryCode: "DO",
    west: -72.0114723981787,
    countryName: "Dominican Republic",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "DOP",
  },
  {
    continent: "AF",
    capital: "Algiers",
    languages: "ar-DZ",
    geonameId: 2589581,
    south: 18.968147,
    isoAlpha3: "DZA",
    north: 37.089801381,
    fipsCode: "AG",
    population: "42228429",
    east: 11.9984999060001,
    isoNumeric: "012",
    areaInSqKm: "2381740.0",
    countryCode: "DZ",
    west: -8.66761116299995,
    countryName: "Algeria",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "DZD",
  },
  {
    continent: "SA",
    capital: "Quito",
    languages: "es-EC",
    geonameId: 3658394,
    south: -5.01615732302488,
    isoAlpha3: "ECU",
    north: 1.43523516349953,
    fipsCode: "EC",
    population: "17084357",
    east: -75.1871465547501,
    isoNumeric: "218",
    areaInSqKm: "283560.0",
    countryCode: "EC",
    west: -81.0836838953894,
    countryName: "Ecuador",
    postalCodeFormat: "@####@",
    continentName: "South America",
    currencyCode: "USD",
  },
  {
    continent: "EU",
    capital: "Tallinn",
    languages: "et,ru",
    geonameId: 453733,
    south: 57.509312800000004,
    isoAlpha3: "EST",
    north: 59.67520158600001,
    fipsCode: "EN",
    population: "1320884",
    east: 28.209323191000003,
    isoNumeric: "233",
    areaInSqKm: "45226.0",
    countryCode: "EE",
    west: 21.828243949,
    countryName: "Estonia",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Cairo",
    languages: "ar-EG,en,fr",
    geonameId: 357994,
    south: 21.724952,
    isoAlpha3: "EGY",
    north: 31.6709930000001,
    fipsCode: "EG",
    population: "98423595",
    east: 35.7935441020001,
    isoNumeric: "818",
    areaInSqKm: "1001450.0",
    countryCode: "EG",
    west: 24.6967750000001,
    countryName: "Egypt",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "EGP",
  },
  {
    continent: "AF",
    capital: "",
    languages: "ar,mey",
    geonameId: 2461445,
    south: 20.771664961000003,
    isoAlpha3: "ESH",
    north: 27.667401638,
    fipsCode: "WI",
    population: "273008",
    east: -8.667525000000001,
    isoNumeric: "732",
    areaInSqKm: "266000.0",
    countryCode: "EH",
    west: -17.10418129,
    countryName: "Western Sahara",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "MAD",
  },
  {
    continent: "AF",
    capital: "Asmara",
    languages: "aa-ER,ar,tig,kun,ti-ER",
    geonameId: 338010,
    south: 12.3543041790001,
    isoAlpha3: "ERI",
    north: 18.004838997,
    fipsCode: "ER",
    population: "6209262",
    east: 43.1368865700001,
    isoNumeric: "232",
    areaInSqKm: "121320.0",
    countryCode: "ER",
    west: 36.434007751,
    countryName: "Eritrea",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "ERN",
  },
  {
    continent: "EU",
    capital: "Madrid",
    languages: "es-ES,ca,gl,eu,oc",
    geonameId: 2510769,
    south: 36.0001044260548,
    isoAlpha3: "ESP",
    north: 43.7913565913767,
    fipsCode: "SP",
    population: "46723749",
    east: 4.32778473043961,
    isoNumeric: "724",
    areaInSqKm: "504782.0",
    countryCode: "ES",
    west: -9.30151567231899,
    countryName: "Spain",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Addis Ababa",
    languages: "am,en-ET,om-ET,ti-ET,so-ET,sid",
    geonameId: 337996,
    south: 3.40413700100004,
    isoAlpha3: "ETH",
    north: 14.894214,
    fipsCode: "ET",
    population: "109224559",
    east: 48.0010560010001,
    isoNumeric: "231",
    areaInSqKm: "1127127.0",
    countryCode: "ET",
    west: 32.997734001,
    countryName: "Ethiopia",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "ETB",
  },
  {
    continent: "EU",
    capital: "Helsinki",
    languages: "fi-FI,sv-FI,smn",
    geonameId: 660013,
    south: 59.807848896,
    isoAlpha3: "FIN",
    north: 70.0922932,
    fipsCode: "FI",
    population: "5518050",
    east: 31.5867034,
    isoNumeric: "246",
    areaInSqKm: "337030.0",
    countryCode: "FI",
    west: 20.548636700000003,
    countryName: "Finland",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "OC",
    capital: "Suva",
    languages: "en-FJ,fj",
    geonameId: 2205218,
    south: -20.673852409000002,
    isoAlpha3: "FJI",
    north: -12.4795295382484,
    fipsCode: "FJ",
    population: "883483",
    east: -178.432146772,
    isoNumeric: "242",
    areaInSqKm: "18270.0",
    countryCode: "FJ",
    west: 177.140015279982,
    countryName: "Fiji",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "FJD",
  },
  {
    continent: "SA",
    capital: "Stanley",
    languages: "en-FK",
    geonameId: 3474414,
    south: -52.383984175,
    isoAlpha3: "FLK",
    north: -51.2331394719999,
    fipsCode: "FK",
    population: "2638",
    east: -57.718087652,
    isoNumeric: "238",
    areaInSqKm: "12173.0",
    countryCode: "FK",
    west: -61.3474566739999,
    countryName: "Falkland Islands",
    postalCodeFormat: "",
    continentName: "South America",
    currencyCode: "FKP",
  },
  {
    continent: "OC",
    capital: "Palikir",
    languages: "en-FM,chk,pon,yap,kos,uli,woe,nkr,kpg",
    geonameId: 2081918,
    south: 1.02629,
    isoAlpha3: "FSM",
    north: 10.08904,
    fipsCode: "FM",
    population: "112640",
    east: 163.03717,
    isoNumeric: "583",
    areaInSqKm: "702.0",
    countryCode: "FM",
    west: 137.33648,
    countryName: "Micronesia",
    postalCodeFormat: "#####",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "EU",
    capital: "Tórshavn",
    languages: "fo,da-FO",
    geonameId: 2622320,
    south: 61.3910302656013,
    isoAlpha3: "FRO",
    north: 62.3938884414274,
    fipsCode: "FO",
    population: "48497",
    east: -6.25655957192113,
    isoNumeric: "234",
    areaInSqKm: "1399.0",
    countryCode: "FO",
    west: -7.688191677774624,
    countryName: "Faroe Islands",
    postalCodeFormat: "###",
    continentName: "Europe",
    currencyCode: "DKK",
  },
  {
    continent: "EU",
    capital: "Paris",
    languages: "fr-FR,frp,br,co,ca,eu,oc",
    geonameId: 3017382,
    south: 41.3645589826522,
    isoAlpha3: "FRA",
    north: 51.0889894407743,
    fipsCode: "FR",
    population: "66987244",
    east: 9.56009360694225,
    isoNumeric: "250",
    areaInSqKm: "547030.0",
    countryCode: "FR",
    west: -5.14127657354623,
    countryName: "France",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Libreville",
    languages: "fr-GA",
    geonameId: 2400553,
    south: -3.96180775999994,
    isoAlpha3: "GAB",
    north: 2.31810900100004,
    fipsCode: "GB",
    population: "2119275",
    east: 14.5269230000001,
    isoNumeric: "266",
    areaInSqKm: "267667.0",
    countryCode: "GA",
    west: 8.69940944700005,
    countryName: "Gabon",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "EU",
    capital: "London",
    languages: "en-GB,cy-GB,gd",
    geonameId: 2635167,
    south: 49.9028622252397,
    isoAlpha3: "GBR",
    north: 59.3607741849963,
    fipsCode: "UK",
    population: "66488991",
    east: 1.7689121033873,
    isoNumeric: "826",
    areaInSqKm: "244820.0",
    countryCode: "GB",
    west: -8.61772077108559,
    countryName: "United Kingdom",
    postalCodeFormat: "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    continentName: "Europe",
    currencyCode: "GBP",
  },
  {
    continent: "NA",
    capital: "St. George's",
    languages: "en-GD",
    geonameId: 3580239,
    south: 11.9869539231552,
    isoAlpha3: "GRD",
    north: 12.318283928171299,
    fipsCode: "GJ",
    population: "111454",
    east: -61.57676970108031,
    isoNumeric: "308",
    areaInSqKm: "344.0",
    countryCode: "GD",
    west: -61.80247620963,
    countryName: "Grenada",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "AS",
    capital: "Tbilisi",
    languages: "ka,ru,hy,az",
    geonameId: 614540,
    south: 41.055156100000005,
    isoAlpha3: "GEO",
    north: 43.586627,
    fipsCode: "GG",
    population: "3731000",
    east: 46.736119,
    isoNumeric: "268",
    areaInSqKm: "69700.0",
    countryCode: "GE",
    west: 40.006604,
    countryName: "Georgia",
    postalCodeFormat: "####",
    continentName: "Asia",
    currencyCode: "GEL",
  },
  {
    continent: "SA",
    capital: "Cayenne",
    languages: "fr-GF",
    geonameId: 3381670,
    south: 2.11107565187642,
    isoAlpha3: "GUF",
    north: 5.74725188917531,
    fipsCode: "FG",
    population: "195506",
    east: -51.619065827085,
    isoNumeric: "254",
    areaInSqKm: "91000.0",
    countryCode: "GF",
    west: -54.6024155447667,
    countryName: "French Guiana",
    postalCodeFormat: "#####",
    continentName: "South America",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "St Peter Port",
    languages: "en,nrf",
    geonameId: 3042362,
    south: 49.407357411,
    isoAlpha3: "GGY",
    north: 49.732650434,
    fipsCode: "GK",
    population: "65228",
    east: -2.15661384,
    isoNumeric: "831",
    areaInSqKm: "78.0",
    countryCode: "GG",
    west: -2.676158606,
    countryName: "Guernsey",
    postalCodeFormat: "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    continentName: "Europe",
    currencyCode: "GBP",
  },
  {
    continent: "AF",
    capital: "Accra",
    languages: "en-GH,ak,ee,tw",
    geonameId: 2300660,
    south: 4.73894544800004,
    isoAlpha3: "GHA",
    north: 11.174952907,
    fipsCode: "GH",
    population: "29767108",
    east: 1.19948138100006,
    isoNumeric: "288",
    areaInSqKm: "239460.0",
    countryCode: "GH",
    west: -3.26078599999994,
    countryName: "Ghana",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "GHS",
  },
  {
    continent: "EU",
    capital: "Gibraltar",
    languages: "en-GI,es,it,pt",
    geonameId: 2411586,
    south: 36.108417452000005,
    isoAlpha3: "GIB",
    north: 36.1550302,
    fipsCode: "GI",
    population: "33718",
    east: -5.337457613000001,
    isoNumeric: "292",
    areaInSqKm: "6.5",
    countryCode: "GI",
    west: -5.366033708000001,
    countryName: "Gibraltar",
    postalCodeFormat: "",
    continentName: "Europe",
    currencyCode: "GIP",
  },
  {
    continent: "NA",
    capital: "Nuuk",
    languages: "kl,da-GL,en",
    geonameId: 3425505,
    south: 59.773352049,
    isoAlpha3: "GRL",
    north: 83.666250438,
    fipsCode: "GL",
    population: "56025",
    east: -11.415399203000002,
    isoNumeric: "304",
    areaInSqKm: "2166086.0",
    countryCode: "GL",
    west: -73.02829874000001,
    countryName: "Greenland",
    postalCodeFormat: "####",
    continentName: "North America",
    currencyCode: "DKK",
  },
  {
    continent: "AF",
    capital: "Banjul",
    languages: "en-GM,mnk,wof,wo,ff",
    geonameId: 2413451,
    south: 13.06389831,
    isoAlpha3: "GMB",
    north: 13.825058100000001,
    fipsCode: "GA",
    population: "2280102",
    east: -13.791386200000002,
    isoNumeric: "270",
    areaInSqKm: "11300.0",
    countryCode: "GM",
    west: -16.813880921000003,
    countryName: "The Gambia",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "GMD",
  },
  {
    continent: "AF",
    capital: "Conakry",
    languages: "fr-GN",
    geonameId: 2420477,
    south: 7.1906045,
    isoAlpha3: "GIN",
    north: 12.674861300000002,
    fipsCode: "GV",
    population: "12414318",
    east: -7.637853000000001,
    isoNumeric: "324",
    areaInSqKm: "245857.0",
    countryCode: "GN",
    west: -14.919164658000001,
    countryName: "Guinea",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "GNF",
  },
  {
    continent: "NA",
    capital: "Basse-Terre",
    languages: "fr-GP",
    geonameId: 3579143,
    south: 15.8665030910918,
    isoAlpha3: "GLP",
    north: 16.5144923539361,
    fipsCode: "GP",
    population: "443000",
    east: -61.0019590353041,
    isoNumeric: "312",
    areaInSqKm: "1780.0",
    countryCode: "GP",
    west: -61.5508178989899,
    countryName: "Guadeloupe",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Malabo",
    languages: "es-GQ,fr,pt",
    geonameId: 2309096,
    south: 0.92086101,
    isoAlpha3: "GNQ",
    north: 2.34792018,
    fipsCode: "EK",
    population: "1308974",
    east: 11.33743668,
    isoNumeric: "226",
    areaInSqKm: "28051.0",
    countryCode: "GQ",
    west: 9.34069443,
    countryName: "Equatorial Guinea",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "EU",
    capital: "Athens",
    languages: "el-GR,en,fr",
    geonameId: 390903,
    south: 34.8020663391466,
    isoAlpha3: "GRC",
    north: 41.7484999849641,
    fipsCode: "GR",
    population: "10727668",
    east: 28.2470831714347,
    isoNumeric: "300",
    areaInSqKm: "131940.0",
    countryCode: "GR",
    west: 19.3736035624134,
    countryName: "Greece",
    postalCodeFormat: "### ##",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AN",
    capital: "Grytviken",
    languages: "en",
    geonameId: 3474415,
    south: -59.46319341,
    isoAlpha3: "SGS",
    north: -53.980896636,
    fipsCode: "SX",
    population: "30",
    east: -26.252069712,
    isoNumeric: "239",
    areaInSqKm: "3903.0",
    countryCode: "GS",
    west: -38.0479509639999,
    countryName: "South Georgia and South Sandwich Islands",
    postalCodeFormat: "",
    continentName: "Antarctica",
    currencyCode: "GBP",
  },
  {
    continent: "NA",
    capital: "Guatemala City",
    languages: "es-GT",
    geonameId: 3595528,
    south: 13.7400210010001,
    isoAlpha3: "GTM",
    north: 17.815695169,
    fipsCode: "GT",
    population: "17247807",
    east: -88.233001934,
    isoNumeric: "320",
    areaInSqKm: "108890.0",
    countryCode: "GT",
    west: -92.231143101,
    countryName: "Guatemala",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "GTQ",
  },
  {
    continent: "OC",
    capital: "Hagåtña",
    languages: "en-GU,ch-GU",
    geonameId: 4043988,
    south: 13.23376,
    isoAlpha3: "GUM",
    north: 13.654402,
    fipsCode: "GQ",
    population: "165768",
    east: 144.956894,
    isoNumeric: "316",
    areaInSqKm: "549.0",
    countryCode: "GU",
    west: 144.618318,
    countryName: "Guam",
    postalCodeFormat: "969##",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "AF",
    capital: "Bissau",
    languages: "pt-GW,pov",
    geonameId: 2372248,
    south: 10.921182632,
    isoAlpha3: "GNB",
    north: 12.686947,
    fipsCode: "PU",
    population: "1874309",
    east: -13.626523,
    isoNumeric: "624",
    areaInSqKm: "36120.0",
    countryCode: "GW",
    west: -16.667235795,
    countryName: "Guinea-Bissau",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "SA",
    capital: "Georgetown",
    languages: "en-GY",
    geonameId: 3378535,
    south: 1.164724,
    isoAlpha3: "GUY",
    north: 8.405275345,
    fipsCode: "GY",
    population: "779004",
    east: -56.49112,
    isoNumeric: "328",
    areaInSqKm: "214970.0",
    countryCode: "GY",
    west: -61.4108317,
    countryName: "Guyana",
    postalCodeFormat: "",
    continentName: "South America",
    currencyCode: "GYD",
  },
  {
    continent: "AS",
    capital: "Hong Kong",
    languages: "zh-HK,yue,zh,en",
    geonameId: 1819730,
    south: 22.1552256413502,
    isoAlpha3: "HKG",
    north: 22.5619493557973,
    fipsCode: "HK",
    population: "7451000",
    east: 114.441993257571,
    isoNumeric: "344",
    areaInSqKm: "1092.0",
    countryCode: "HK",
    west: 113.839212676903,
    countryName: "Hong Kong",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "HKD",
  },
  {
    continent: "AN",
    capital: "",
    languages: "",
    geonameId: 1547314,
    south: -53.194220878,
    isoAlpha3: "HMD",
    north: -52.915310109,
    fipsCode: "HM",
    population: "0",
    east: 73.876616094,
    isoNumeric: "334",
    areaInSqKm: "412.0",
    countryCode: "HM",
    west: 72.583712483,
    countryName: "Heard and McDonald Islands",
    postalCodeFormat: "",
    continentName: "Antarctica",
    currencyCode: "AUD",
  },
  {
    continent: "NA",
    capital: "Tegucigalpa",
    languages: "es-HN,cab,miq",
    geonameId: 3608932,
    south: 12.9808202,
    isoAlpha3: "HND",
    north: 16.515996751,
    fipsCode: "HO",
    population: "9587522",
    east: -83.12893683600001,
    isoNumeric: "340",
    areaInSqKm: "112090.0",
    countryCode: "HN",
    west: -89.3564822,
    countryName: "Honduras",
    postalCodeFormat: "@@####",
    continentName: "North America",
    currencyCode: "HNL",
  },
  {
    continent: "EU",
    capital: "Zagreb",
    languages: "hr-HR,sr",
    geonameId: 3202326,
    south: 42.686594828000004,
    isoAlpha3: "HRV",
    north: 46.555020500000005,
    fipsCode: "HR",
    population: "3871833",
    east: 19.447372100000003,
    isoNumeric: "191",
    areaInSqKm: "56542.0",
    countryCode: "HR",
    west: 13.489818351,
    countryName: "Croatia",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "NA",
    capital: "Port-au-Prince",
    languages: "ht,fr-HT",
    geonameId: 3723988,
    south: 18.021640916000003,
    isoAlpha3: "HTI",
    north: 20.089481152,
    fipsCode: "HA",
    population: "11123176",
    east: -71.62175400000001,
    isoNumeric: "332",
    areaInSqKm: "27750.0",
    countryCode: "HT",
    west: -74.480430603,
    countryName: "Haiti",
    postalCodeFormat: "HT####",
    continentName: "North America",
    currencyCode: "HTG",
  },
  {
    continent: "EU",
    capital: "Budapest",
    languages: "hu-HU",
    geonameId: 719819,
    south: 45.7370495590001,
    isoAlpha3: "HUN",
    north: 48.585336,
    fipsCode: "HU",
    population: "9768785",
    east: 22.896564336,
    isoNumeric: "348",
    areaInSqKm: "93030.0",
    countryCode: "HU",
    west: 16.113795,
    countryName: "Hungary",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "HUF",
  },
  {
    continent: "AS",
    capital: "Jakarta",
    languages: "id,en,nl,jv",
    geonameId: 1643084,
    south: -10.9431056999999,
    isoAlpha3: "IDN",
    north: 5.90722980000004,
    fipsCode: "ID",
    population: "267663435",
    east: 141.0194,
    isoNumeric: "360",
    areaInSqKm: "1919440.0",
    countryCode: "ID",
    west: 95.0111465000001,
    countryName: "Indonesia",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "IDR",
  },
  {
    continent: "EU",
    capital: "Dublin",
    languages: "en-IE,ga-IE",
    geonameId: 2963597,
    south: 51.4475491577615,
    isoAlpha3: "IRL",
    north: 55.3829431564742,
    fipsCode: "EI",
    population: "4853506",
    east: -5.99804990172185,
    isoNumeric: "372",
    areaInSqKm: "70280.0",
    countryCode: "IE",
    west: -10.4800035816853,
    countryName: "Ireland",
    postalCodeFormat: "@@@ @@@@",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AS",
    capital: "",
    languages: "he,ar-IL,en-IL,",
    geonameId: 294640,
    south: 29.490654862,
    isoAlpha3: "ISR",
    north: 33.2908350000001,
    fipsCode: "IS",
    population: "8883800",
    east: 35.67033,
    isoNumeric: "376",
    areaInSqKm: "20770.0",
    countryCode: "IL",
    west: 34.267257,
    countryName: "Israel",
    postalCodeFormat: "#######",
    continentName: "Asia",
    currencyCode: "ILS",
  },
  {
    continent: "EU",
    capital: "Douglas",
    languages: "en,gv",
    geonameId: 3042225,
    south: 54.0536251033159,
    isoAlpha3: "IMN",
    north: 54.4178825685258,
    fipsCode: "IM",
    population: "84077",
    east: -4.30802074695987,
    isoNumeric: "833",
    areaInSqKm: "572.0",
    countryCode: "IM",
    west: -4.79430574571353,
    countryName: "Isle of Man",
    postalCodeFormat: "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    continentName: "Europe",
    currencyCode: "GBP",
  },
  {
    continent: "AS",
    capital: "New Delhi",
    languages:
      "en-IN,hi,bn,te,mr,ta,ur,gu,kn,ml,or,pa,as,bh,sat,ks,ne,sd,kok,doi,mni,sit,sa,fr,lus,inc",
    geonameId: 1269750,
    south: 6.756488981,
    isoAlpha3: "IND",
    north: 35.506103515625,
    fipsCode: "IN",
    population: "1352617328",
    east: 97.4152926679075,
    isoNumeric: "356",
    areaInSqKm: "3287590.0",
    countryCode: "IN",
    west: 68.451157765,
    countryName: "India",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "INR",
  },
  {
    continent: "AS",
    capital: "",
    languages: "en-IO",
    geonameId: 1282588,
    south: -6.207870302000001,
    isoAlpha3: "IOT",
    north: -5.279533272,
    fipsCode: "IO",
    population: "4000",
    east: 72.230204978,
    isoNumeric: "086",
    areaInSqKm: "60.0",
    countryCode: "IO",
    west: 71.311290027,
    countryName: "British Indian Ocean Territory",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "USD",
  },
  {
    continent: "AS",
    capital: "Baghdad",
    languages: "ar-IQ,ku,hy",
    geonameId: 99237,
    south: 29.0612080000001,
    isoAlpha3: "IRQ",
    north: 37.380746001,
    fipsCode: "IZ",
    population: "38433600",
    east: 48.6117360000001,
    isoNumeric: "368",
    areaInSqKm: "437072.0",
    countryCode: "IQ",
    west: 38.7936740000001,
    countryName: "Iraq",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "IQD",
  },
  {
    continent: "AS",
    capital: "Tehran",
    languages: "fa-IR,ku",
    geonameId: 130758,
    south: 25.060388566,
    isoAlpha3: "IRN",
    north: 39.7822393340001,
    fipsCode: "IR",
    population: "81800269",
    east: 63.333337,
    isoNumeric: "364",
    areaInSqKm: "1648000.0",
    countryCode: "IR",
    west: 44.032638708,
    countryName: "Iran",
    postalCodeFormat: "##########",
    continentName: "Asia",
    currencyCode: "IRR",
  },
  {
    continent: "EU",
    capital: "Reykjavik",
    languages: "is,en,de,da,sv,no",
    geonameId: 2629691,
    south: 63.394392778588,
    isoAlpha3: "ISL",
    north: 66.5377933098397,
    fipsCode: "IC",
    population: "353574",
    east: -13.4946206239501,
    isoNumeric: "352",
    areaInSqKm: "103000.0",
    countryCode: "IS",
    west: -24.5326753866625,
    countryName: "Iceland",
    postalCodeFormat: "###",
    continentName: "Europe",
    currencyCode: "ISK",
  },
  {
    continent: "EU",
    capital: "Rome",
    languages: "it-IT,de-IT,fr-IT,sc,ca,co,sl",
    geonameId: 3175395,
    south: 36.6440816661648,
    isoAlpha3: "ITA",
    north: 47.0917837415439,
    fipsCode: "IT",
    population: "60431283",
    east: 18.5203814091888,
    isoNumeric: "380",
    areaInSqKm: "301230.0",
    countryCode: "IT",
    west: 6.62662135986088,
    countryName: "Italy",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Saint Helier",
    languages: "en,fr,nrf",
    geonameId: 3042142,
    south: 49.162639832,
    isoAlpha3: "JEY",
    north: 49.262085141,
    fipsCode: "JE",
    population: "90812",
    east: -2.016521809,
    isoNumeric: "832",
    areaInSqKm: "116.0",
    countryCode: "JE",
    west: -2.256828534,
    countryName: "Jersey",
    postalCodeFormat: "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
    continentName: "Europe",
    currencyCode: "GBP",
  },
  {
    continent: "NA",
    capital: "Kingston",
    languages: "en-JM",
    geonameId: 3489940,
    south: 17.7059966193696,
    isoAlpha3: "JAM",
    north: 18.524766185516,
    fipsCode: "JM",
    population: "2934855",
    east: -76.1830989848426,
    isoNumeric: "388",
    areaInSqKm: "10991.0",
    countryCode: "JM",
    west: -78.3690062954957,
    countryName: "Jamaica",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "JMD",
  },
  {
    continent: "AS",
    capital: "Amman",
    languages: "ar-JO,en",
    geonameId: 248816,
    south: 29.1850360010001,
    isoAlpha3: "JOR",
    north: 33.374735,
    fipsCode: "JO",
    population: "9956011",
    east: 39.3011540000001,
    isoNumeric: "400",
    areaInSqKm: "92300.0",
    countryCode: "JO",
    west: 34.955471039,
    countryName: "Jordan",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "JOD",
  },
  {
    continent: "AS",
    capital: "Tokyo",
    languages: "ja",
    geonameId: 1861060,
    south: 24.255169441,
    isoAlpha3: "JPN",
    north: 45.52295736,
    fipsCode: "JA",
    population: "126529100",
    east: 145.817458885,
    isoNumeric: "392",
    areaInSqKm: "377835.0",
    countryCode: "JP",
    west: 122.933653061,
    countryName: "Japan",
    postalCodeFormat: "###-####",
    continentName: "Asia",
    currencyCode: "JPY",
  },
  {
    continent: "AF",
    capital: "Nairobi",
    languages: "en-KE,sw-KE",
    geonameId: 192950,
    south: -4.67989449199996,
    isoAlpha3: "KEN",
    north: 5.03342100100002,
    fipsCode: "KE",
    population: "51393010",
    east: 41.9069450000001,
    isoNumeric: "404",
    areaInSqKm: "582650.0",
    countryCode: "KE",
    west: 33.9098210000001,
    countryName: "Kenya",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "KES",
  },
  {
    continent: "AS",
    capital: "Bishkek",
    languages: "ky,uz,ru",
    geonameId: 1527747,
    south: 39.180972600000004,
    isoAlpha3: "KGZ",
    north: 43.266184800000005,
    fipsCode: "KG",
    population: "6315800",
    east: 80.2281514,
    isoNumeric: "417",
    areaInSqKm: "198500.0",
    countryCode: "KG",
    west: 69.26406010000001,
    countryName: "Kyrgyzstan",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "KGS",
  },
  {
    continent: "AS",
    capital: "Phnom Penh",
    languages: "km,fr,en",
    geonameId: 1831722,
    south: 10.4044675,
    isoAlpha3: "KHM",
    north: 14.690179,
    fipsCode: "CB",
    population: "16249798",
    east: 107.62768700000001,
    isoNumeric: "116",
    areaInSqKm: "181040.0",
    countryCode: "KH",
    west: 102.3336584,
    countryName: "Cambodia",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "KHR",
  },
  {
    continent: "OC",
    capital: "Tarawa",
    languages: "en-KI,gil",
    geonameId: 4030945,
    south: -11.4460499999991,
    isoAlpha3: "KIR",
    north: 3.93942799999973,
    fipsCode: "KR",
    population: "115847",
    east: -150.2345115032905,
    isoNumeric: "296",
    areaInSqKm: "811.0",
    countryCode: "KI",
    west: 169.548692,
    countryName: "Kiribati",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "AF",
    capital: "Moroni",
    languages: "ar,fr-KM",
    geonameId: 921929,
    south: -12.391376681,
    isoAlpha3: "COM",
    north: -11.364901803,
    fipsCode: "CN",
    population: "832322",
    east: 44.540496038,
    isoNumeric: "174",
    areaInSqKm: "2170.0",
    countryCode: "KM",
    west: 43.229447492000006,
    countryName: "Comoros",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "KMF",
  },
  {
    continent: "NA",
    capital: "Basseterre",
    languages: "en-KN",
    geonameId: 3575174,
    south: 17.094041539000003,
    isoAlpha3: "KNA",
    north: 17.417971063,
    fipsCode: "SC",
    population: "52441",
    east: -62.539445108,
    isoNumeric: "659",
    areaInSqKm: "261.0",
    countryCode: "KN",
    west: -62.864195683000005,
    countryName: "St Kitts and Nevis",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "AS",
    capital: "Pyongyang",
    languages: "ko-KP",
    geonameId: 1873107,
    south: 37.676415029000005,
    isoAlpha3: "PRK",
    north: 43.009170000000005,
    fipsCode: "KN",
    population: "25549819",
    east: 130.69807515,
    isoNumeric: "408",
    areaInSqKm: "120540.0",
    countryCode: "KP",
    west: 124.30949351800001,
    countryName: "North Korea",
    postalCodeFormat: "###-###",
    continentName: "Asia",
    currencyCode: "KPW",
  },
  {
    continent: "AS",
    capital: "Seoul",
    languages: "ko-KR,en",
    geonameId: 1835841,
    south: 33.1954102977009,
    isoAlpha3: "KOR",
    north: 38.5933891092225,
    fipsCode: "KS",
    population: "51635256",
    east: 129.583016157998,
    isoNumeric: "410",
    areaInSqKm: "98480.0",
    countryCode: "KR",
    west: 125.887442375577,
    countryName: "South Korea",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "KRW",
  },
  {
    continent: "AS",
    capital: "Kuwait City",
    languages: "ar-KW,en",
    geonameId: 285570,
    south: 28.524446,
    isoAlpha3: "KWT",
    north: 30.103699100000004,
    fipsCode: "KU",
    population: "4137309",
    east: 48.430707508000005,
    isoNumeric: "414",
    areaInSqKm: "17820.0",
    countryCode: "KW",
    west: 46.55304,
    countryName: "Kuwait",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "KWD",
  },
  {
    continent: "NA",
    capital: "George Town",
    languages: "en-KY",
    geonameId: 3580718,
    south: 19.262405779,
    isoAlpha3: "CYM",
    north: 19.756924232000003,
    fipsCode: "CJ",
    population: "64174",
    east: -79.722724161,
    isoNumeric: "136",
    areaInSqKm: "262.0",
    countryCode: "KY",
    west: -81.420590362,
    countryName: "Cayman Islands",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "KYD",
  },
  {
    continent: "AS",
    capital: "Nur-Sultan",
    languages: "kk,ru",
    geonameId: 1522867,
    south: 40.5686884990001,
    isoAlpha3: "KAZ",
    north: 55.441984001,
    fipsCode: "KZ",
    population: "18276499",
    east: 87.3154150010001,
    isoNumeric: "398",
    areaInSqKm: "2717300.0",
    countryCode: "KZ",
    west: 46.4936720000001,
    countryName: "Kazakhstan",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "KZT",
  },
  {
    continent: "AS",
    capital: "Vientiane",
    languages: "lo,fr,en",
    geonameId: 1655842,
    south: 13.909720001,
    isoAlpha3: "LAO",
    north: 22.50904495,
    fipsCode: "LA",
    population: "7061507",
    east: 107.635093936,
    isoNumeric: "418",
    areaInSqKm: "236800.0",
    countryCode: "LA",
    west: 100.083872,
    countryName: "Laos",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "LAK",
  },
  {
    continent: "AS",
    capital: "Beirut",
    languages: "ar-LB,fr-LB,en,hy",
    geonameId: 272103,
    south: 33.0550260000001,
    isoAlpha3: "LBN",
    north: 34.6920900000001,
    fipsCode: "LE",
    population: "6848925",
    east: 36.62372,
    isoNumeric: "422",
    areaInSqKm: "10400.0",
    countryCode: "LB",
    west: 35.103668213,
    countryName: "Lebanon",
    postalCodeFormat: "#### ####|####",
    continentName: "Asia",
    currencyCode: "LBP",
  },
  {
    continent: "NA",
    capital: "Castries",
    languages: "en-LC",
    geonameId: 3576468,
    south: 13.7072692224982,
    isoAlpha3: "LCA",
    north: 14.110317287646,
    fipsCode: "ST",
    population: "181889",
    east: -60.8732306422271,
    isoNumeric: "662",
    areaInSqKm: "616.0",
    countryCode: "LC",
    west: -61.07995730159752,
    countryName: "Saint Lucia",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "EU",
    capital: "Vaduz",
    languages: "de-LI",
    geonameId: 3042058,
    south: 47.0484281,
    isoAlpha3: "LIE",
    north: 47.270574200000006,
    fipsCode: "LS",
    population: "37910",
    east: 9.6356923,
    isoNumeric: "438",
    areaInSqKm: "160.0",
    countryCode: "LI",
    west: 9.4716831,
    countryName: "Liechtenstein",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "CHF",
  },
  {
    continent: "AS",
    capital: "Colombo",
    languages: "si,ta,en",
    geonameId: 1227603,
    south: 5.91869676126554,
    isoAlpha3: "LKA",
    north: 9.83586297688552,
    fipsCode: "CE",
    population: "21670000",
    east: 81.8790900303934,
    isoNumeric: "144",
    areaInSqKm: "65610.0",
    countryCode: "LK",
    west: 79.6505518289324,
    countryName: "Sri Lanka",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "LKR",
  },
  {
    continent: "AF",
    capital: "Monrovia",
    languages: "en-LR",
    geonameId: 2275384,
    south: 4.35326143300006,
    isoAlpha3: "LBR",
    north: 8.55198600000006,
    fipsCode: "LI",
    population: "4818977",
    east: -7.36925499999995,
    isoNumeric: "430",
    areaInSqKm: "111370.0",
    countryCode: "LR",
    west: -11.4993114059999,
    countryName: "Liberia",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "LRD",
  },
  {
    continent: "AF",
    capital: "Maseru",
    languages: "en-LS,st,zu,xh",
    geonameId: 932692,
    south: -30.6755750029999,
    isoAlpha3: "LSO",
    north: -28.5708,
    fipsCode: "LT",
    population: "2108132",
    east: 29.4557099420001,
    isoNumeric: "426",
    areaInSqKm: "30355.0",
    countryCode: "LS",
    west: 27.011229998,
    countryName: "Lesotho",
    postalCodeFormat: "###",
    continentName: "Africa",
    currencyCode: "LSL",
  },
  {
    continent: "EU",
    capital: "Vilnius",
    languages: "lt,ru,pl",
    geonameId: 597427,
    south: 53.89679499,
    isoAlpha3: "LTU",
    north: 56.4504065100001,
    fipsCode: "LH",
    population: "2789533",
    east: 26.8355231,
    isoNumeric: "440",
    areaInSqKm: "65200.0",
    countryCode: "LT",
    west: 20.941528,
    countryName: "Lithuania",
    postalCodeFormat: "LT-#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Luxembourg",
    languages: "lb,de-LU,fr-LU",
    geonameId: 2960313,
    south: 49.447858677765716,
    isoAlpha3: "LUX",
    north: 50.182772453796446,
    fipsCode: "LU",
    population: "607728",
    east: 6.5308980672559525,
    isoNumeric: "442",
    areaInSqKm: "2586.0",
    countryCode: "LU",
    west: 5.735698938390786,
    countryName: "Luxembourg",
    postalCodeFormat: "L-####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Riga",
    languages: "lv,ru,lt",
    geonameId: 458258,
    south: 55.6746813658222,
    isoAlpha3: "LVA",
    north: 58.0855687987932,
    fipsCode: "LG",
    population: "1926542",
    east: 28.2414937252949,
    isoNumeric: "428",
    areaInSqKm: "64589.0",
    countryCode: "LV",
    west: 20.9621192713114,
    countryName: "Latvia",
    postalCodeFormat: "LV-####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Tripoli",
    languages: "ar-LY,it,en",
    geonameId: 2215636,
    south: 19.5,
    isoAlpha3: "LBY",
    north: 33.166502251000004,
    fipsCode: "LY",
    population: "6678567",
    east: 25.149240494,
    isoNumeric: "434",
    areaInSqKm: "1759540.0",
    countryCode: "LY",
    west: 9.391466300000001,
    countryName: "Libya",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "LYD",
  },
  {
    continent: "AF",
    capital: "Rabat",
    languages: "ar-MA,ber,fr",
    geonameId: 2542007,
    south: 27.6672694750001,
    isoAlpha3: "MAR",
    north: 35.922341095,
    fipsCode: "MO",
    population: "36029138",
    east: -0.996975780999946,
    isoNumeric: "504",
    areaInSqKm: "446550.0",
    countryCode: "MA",
    west: -13.1722970399999,
    countryName: "Morocco",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "MAD",
  },
  {
    continent: "EU",
    capital: "Monaco",
    languages: "fr-MC,en,it",
    geonameId: 2993457,
    south: 43.724488524,
    isoAlpha3: "MCO",
    north: 43.7519093,
    fipsCode: "MN",
    population: "38682",
    east: 7.440037831000001,
    isoNumeric: "492",
    areaInSqKm: "1.95",
    countryCode: "MC",
    west: 7.409077600000001,
    countryName: "Monaco",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Chișinău",
    languages: "ro,ru,gag,tr",
    geonameId: 617790,
    south: 45.4674379630001,
    isoAlpha3: "MDA",
    north: 48.492029003,
    fipsCode: "MD",
    population: "3545883",
    east: 30.1635900000001,
    isoNumeric: "498",
    areaInSqKm: "33843.0",
    countryCode: "MD",
    west: 26.6164249990001,
    countryName: "Moldova",
    postalCodeFormat: "MD-####",
    continentName: "Europe",
    currencyCode: "MDL",
  },
  {
    continent: "EU",
    capital: "Podgorica",
    languages: "sr,hu,bs,sq,hr,rom",
    geonameId: 3194884,
    south: 41.868751527,
    isoAlpha3: "MNE",
    north: 43.558230232,
    fipsCode: "MJ",
    population: "622345",
    east: 20.352926,
    isoNumeric: "499",
    areaInSqKm: "14026.0",
    countryCode: "ME",
    west: 18.4335595800001,
    countryName: "Montenegro",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "NA",
    capital: "Marigot",
    languages: "fr",
    geonameId: 3578421,
    south: 18.0457313,
    isoAlpha3: "MAF",
    north: 18.124597291,
    fipsCode: "RN",
    population: "37264",
    east: -63.010251297,
    isoNumeric: "663",
    areaInSqKm: "53.0",
    countryCode: "MF",
    west: -63.153103465,
    countryName: "Saint Martin",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Antananarivo",
    languages: "fr-MG,mg",
    geonameId: 1062947,
    south: -25.604970374,
    isoAlpha3: "MDG",
    north: -11.952634594000001,
    fipsCode: "MA",
    population: "26262368",
    east: 50.486374859,
    isoNumeric: "450",
    areaInSqKm: "587040.0",
    countryCode: "MG",
    west: 43.220079751,
    countryName: "Madagascar",
    postalCodeFormat: "###",
    continentName: "Africa",
    currencyCode: "MGA",
  },
  {
    continent: "OC",
    capital: "Majuro",
    languages: "mh,en-MH",
    geonameId: 2080185,
    south: 5.590593336,
    isoAlpha3: "MHL",
    north: 14.630405313,
    fipsCode: "RM",
    population: "58413",
    east: 171.93520866900002,
    isoNumeric: "584",
    areaInSqKm: "181.3",
    countryCode: "MH",
    west: 165.52220278500002,
    countryName: "Marshall Islands",
    postalCodeFormat: "#####-####",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "EU",
    capital: "Skopje",
    languages: "mk,sq,tr,rmm,sr",
    geonameId: 718075,
    south: 40.8539489400001,
    isoAlpha3: "MKD",
    north: 42.3736460000001,
    fipsCode: "MK",
    population: "2082958",
    east: 23.0340440310001,
    isoNumeric: "807",
    areaInSqKm: "25333.0",
    countryCode: "MK",
    west: 20.4524230000001,
    countryName: "North Macedonia",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "MKD",
  },
  {
    continent: "AF",
    capital: "Bamako",
    languages: "fr-ML,bm",
    geonameId: 2453866,
    south: 10.147811,
    isoAlpha3: "MLI",
    north: 25.001084,
    fipsCode: "ML",
    population: "19077690",
    east: 4.26666786900006,
    isoNumeric: "466",
    areaInSqKm: "1240000.0",
    countryCode: "ML",
    west: -12.240344643,
    countryName: "Mali",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "AS",
    capital: "Nay Pyi Taw",
    languages: "my",
    geonameId: 1327865,
    south: 9.785348390000001,
    isoAlpha3: "MMR",
    north: 28.547763300000003,
    fipsCode: "BM",
    population: "53708395",
    east: 101.1702717,
    isoNumeric: "104",
    areaInSqKm: "678500.0",
    countryCode: "MM",
    west: 92.17197780000001,
    countryName: "Myanmar",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "MMK",
  },
  {
    continent: "AS",
    capital: "Ulaanbaatar",
    languages: "mn,ru",
    geonameId: 2029969,
    south: 41.5818330000001,
    isoAlpha3: "MNG",
    north: 52.1483550020001,
    fipsCode: "MG",
    population: "3170208",
    east: 119.931509803,
    isoNumeric: "496",
    areaInSqKm: "1565000.0",
    countryCode: "MN",
    west: 87.7344790560001,
    countryName: "Mongolia",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "MNT",
  },
  {
    continent: "AS",
    capital: "Macao",
    languages: "zh,zh-MO,pt",
    geonameId: 1821275,
    south: 22.109714116000003,
    isoAlpha3: "MAC",
    north: 22.217059000000003,
    fipsCode: "MC",
    population: "631636",
    east: 113.59286193700001,
    isoNumeric: "446",
    areaInSqKm: "254.0",
    countryCode: "MO",
    west: 113.52872988200001,
    countryName: "Macao",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "MOP",
  },
  {
    continent: "OC",
    capital: "Saipan",
    languages: "fil,tl,zh,ch-MP,en-MP",
    geonameId: 4041468,
    south: 14.11023,
    isoAlpha3: "MNP",
    north: 20.55344,
    fipsCode: "CQ",
    population: "56882",
    east: 146.06528,
    isoNumeric: "580",
    areaInSqKm: "477.0",
    countryCode: "MP",
    west: 144.88626,
    countryName: "Northern Mariana Islands",
    postalCodeFormat: "#####",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "NA",
    capital: "Fort-de-France",
    languages: "fr-MQ",
    geonameId: 3570311,
    south: 14.3946961023016,
    isoAlpha3: "MTQ",
    north: 14.8787232943029,
    fipsCode: "MB",
    population: "432900",
    east: -60.8096896756103,
    isoNumeric: "474",
    areaInSqKm: "1100.0",
    countryCode: "MQ",
    west: -61.229041406022,
    countryName: "Martinique",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Nouakchott",
    languages: "ar-MR,fuc,snk,fr,mey,wo",
    geonameId: 2378080,
    south: 14.721273,
    isoAlpha3: "MRT",
    north: 27.3158917,
    fipsCode: "MR",
    population: "4403319",
    east: -4.8341333,
    isoNumeric: "478",
    areaInSqKm: "1030700.0",
    countryCode: "MR",
    west: -17.068727600000003,
    countryName: "Mauritania",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "MRU",
  },
  {
    continent: "NA",
    capital: "Plymouth",
    languages: "en-MS",
    geonameId: 3578097,
    south: 16.674434235,
    isoAlpha3: "MSR",
    north: 16.823976028,
    fipsCode: "MH",
    population: "9341",
    east: -62.144368171,
    isoNumeric: "500",
    areaInSqKm: "102.0",
    countryCode: "MS",
    west: -62.241642326000004,
    countryName: "Montserrat",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "EU",
    capital: "Valletta",
    languages: "mt,en-MT",
    geonameId: 2562770,
    south: 35.8061835000002,
    isoAlpha3: "MLT",
    north: 36.0821530995456,
    fipsCode: "MT",
    population: "483530",
    east: 14.5764915000002,
    isoNumeric: "470",
    areaInSqKm: "316.0",
    countryCode: "MT",
    west: 14.1834251000001,
    countryName: "Malta",
    postalCodeFormat: "@@@ ####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Port Louis",
    languages: "en-MU,bho,fr",
    geonameId: 934292,
    south: -20.525962167000003,
    isoAlpha3: "MUS",
    north: -10.336914977000001,
    fipsCode: "MP",
    population: "1265303",
    east: 63.502770681,
    isoNumeric: "480",
    areaInSqKm: "2040.0",
    countryCode: "MU",
    west: 56.585206416000005,
    countryName: "Mauritius",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "MUR",
  },
  {
    continent: "AS",
    capital: "Malé",
    languages: "dv,en",
    geonameId: 1282028,
    south: -0.703436237,
    isoAlpha3: "MDV",
    north: 7.094160512,
    fipsCode: "MV",
    population: "515696",
    east: 73.59106653,
    isoNumeric: "462",
    areaInSqKm: "300.0",
    countryCode: "MV",
    west: 72.714488708,
    countryName: "Maldives",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "MVR",
  },
  {
    continent: "AF",
    capital: "Lilongwe",
    languages: "ny,yao,tum,swk",
    geonameId: 927384,
    south: -17.1295217059999,
    isoAlpha3: "MWI",
    north: -9.36722739199996,
    fipsCode: "MI",
    population: "17563749",
    east: 35.9185731040001,
    isoNumeric: "454",
    areaInSqKm: "118480.0",
    countryCode: "MW",
    west: 32.6725205490001,
    countryName: "Malawi",
    postalCodeFormat: "######",
    continentName: "Africa",
    currencyCode: "MWK",
  },
  {
    continent: "NA",
    capital: "Mexico City",
    languages: "es-MX",
    geonameId: 3996063,
    south: 14.534548000000001,
    isoAlpha3: "MEX",
    north: 32.7187271,
    fipsCode: "MX",
    population: "126190788",
    east: -86.710518546,
    isoNumeric: "484",
    areaInSqKm: "1972550.0",
    countryCode: "MX",
    west: -118.365853993,
    countryName: "Mexico",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "MXN",
  },
  {
    continent: "AS",
    capital: "Kuala Lumpur",
    languages: "ms-MY,en,zh,ta,te,ml,pa,th",
    geonameId: 1733045,
    south: 0.855000972000028,
    isoAlpha3: "MYS",
    north: 7.36333513300002,
    fipsCode: "MY",
    population: "31528585",
    east: 119.269721985,
    isoNumeric: "458",
    areaInSqKm: "329750.0",
    countryCode: "MY",
    west: 99.6407165520001,
    countryName: "Malaysia",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "MYR",
  },
  {
    continent: "AF",
    capital: "Maputo",
    languages: "pt-MZ,vmw",
    geonameId: 1036973,
    south: -26.868162,
    isoAlpha3: "MOZ",
    north: -10.4731756319999,
    fipsCode: "MZ",
    population: "29495962",
    east: 40.838104211,
    isoNumeric: "508",
    areaInSqKm: "801590.0",
    countryCode: "MZ",
    west: 30.2155500000001,
    countryName: "Mozambique",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "MZN",
  },
  {
    continent: "AF",
    capital: "Windhoek",
    languages: "en-NA,af,de,hz,naq",
    geonameId: 3355338,
    south: -28.9706389999999,
    isoAlpha3: "NAM",
    north: -16.963488173,
    fipsCode: "WA",
    population: "2448255",
    east: 25.2617520000001,
    isoNumeric: "516",
    areaInSqKm: "825418.0",
    countryCode: "NA",
    west: 11.737502061,
    countryName: "Namibia",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "NAD",
  },
  {
    continent: "OC",
    capital: "Noumea",
    languages: "fr-NC",
    geonameId: 2139685,
    south: -22.695222359000002,
    isoAlpha3: "NCL",
    north: -19.540235966,
    fipsCode: "NC",
    population: "284060",
    east: 168.13386857,
    isoNumeric: "540",
    areaInSqKm: "19060.0",
    countryCode: "NC",
    west: 163.56999618400002,
    countryName: "New Caledonia",
    postalCodeFormat: "#####",
    continentName: "Oceania",
    currencyCode: "XPF",
  },
  {
    continent: "AF",
    capital: "Niamey",
    languages: "fr-NE,ha,kr,dje",
    geonameId: 2440476,
    south: 11.6937560000001,
    isoAlpha3: "NER",
    north: 23.5149999920001,
    fipsCode: "NG",
    population: "22442948",
    east: 15.9990340000001,
    isoNumeric: "562",
    areaInSqKm: "1267000.0",
    countryCode: "NE",
    west: 0.162193643000023,
    countryName: "Niger",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "OC",
    capital: "Kingston",
    languages: "en-NF",
    geonameId: 2155115,
    south: -29.0633027,
    isoAlpha3: "NFK",
    north: -28.995059758000004,
    fipsCode: "NF",
    population: "1828",
    east: 167.997572934,
    isoNumeric: "574",
    areaInSqKm: "34.6",
    countryCode: "NF",
    west: 167.914101442,
    countryName: "Norfolk Island",
    postalCodeFormat: "####",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "AF",
    capital: "Abuja",
    languages: "en-NG,ha,yo,ig,ff",
    geonameId: 2328926,
    south: 4.27058531900002,
    isoAlpha3: "NGA",
    north: 13.885645000000068,
    fipsCode: "NI",
    population: "195874740",
    east: 14.677982000000043,
    isoNumeric: "566",
    areaInSqKm: "923768.0",
    countryCode: "NG",
    west: 2.663560999000026,
    countryName: "Nigeria",
    postalCodeFormat: "######",
    continentName: "Africa",
    currencyCode: "NGN",
  },
  {
    continent: "NA",
    capital: "Managua",
    languages: "es-NI,en",
    geonameId: 3617476,
    south: 10.708055,
    isoAlpha3: "NIC",
    north: 15.029737,
    fipsCode: "NU",
    population: "6465513",
    east: -82.735454229,
    isoNumeric: "558",
    areaInSqKm: "129494.0",
    countryCode: "NI",
    west: -87.69112585500001,
    countryName: "Nicaragua",
    postalCodeFormat: "###-###-#",
    continentName: "North America",
    currencyCode: "NIO",
  },
  {
    continent: "EU",
    capital: "Amsterdam",
    languages: "nl-NL,fy-NL",
    geonameId: 2750405,
    south: 50.7503674993741,
    isoAlpha3: "NLD",
    north: 53.5157125645109,
    fipsCode: "NL",
    population: "17231017",
    east: 7.22749859212922,
    isoNumeric: "528",
    areaInSqKm: "41526.0",
    countryCode: "NL",
    west: 3.35837827202,
    countryName: "Netherlands",
    postalCodeFormat: "#### @@",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Oslo",
    languages: "no,nb,nn,se,fi",
    geonameId: 3144096,
    south: 57.97987783489344,
    isoAlpha3: "NOR",
    north: 71.1854764998959,
    fipsCode: "NO",
    population: "5314336",
    east: 31.063740342248376,
    isoNumeric: "578",
    areaInSqKm: "324220.0",
    countryCode: "NO",
    west: 4.64182374183584,
    countryName: "Norway",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "NOK",
  },
  {
    continent: "AS",
    capital: "Kathmandu",
    languages: "ne,en",
    geonameId: 1282988,
    south: 26.3479660710001,
    isoAlpha3: "NPL",
    north: 30.447389748,
    fipsCode: "NP",
    population: "28087871",
    east: 88.2015257450001,
    isoNumeric: "524",
    areaInSqKm: "140800.0",
    countryCode: "NP",
    west: 80.058450824,
    countryName: "Nepal",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "NPR",
  },
  {
    continent: "OC",
    capital: "Yaren District",
    languages: "na,en-NR",
    geonameId: 2110425,
    south: -0.5541467234752249,
    isoAlpha3: "NRU",
    north: -0.502657000000004,
    fipsCode: "NR",
    population: "12704",
    east: 166.95899600000007,
    isoNumeric: "520",
    areaInSqKm: "21.0",
    countryCode: "NR",
    west: 166.90968999999996,
    countryName: "Nauru",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "OC",
    capital: "Alofi",
    languages: "niu,en-NU",
    geonameId: 4036232,
    south: -19.154505229,
    isoAlpha3: "NIU",
    north: -18.952488991000003,
    fipsCode: "NE",
    population: "2166",
    east: -169.774500025,
    isoNumeric: "570",
    areaInSqKm: "260.0",
    countryCode: "NU",
    west: -169.95010424900002,
    countryName: "Niue",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "NZD",
  },
  {
    continent: "OC",
    capital: "Wellington",
    languages: "en-NZ,mi",
    geonameId: 2186224,
    south: -47.290029537,
    isoAlpha3: "NZL",
    north: -34.392812824,
    fipsCode: "NZ",
    population: "4885500",
    east: -180,
    isoNumeric: "554",
    areaInSqKm: "268680.0",
    countryCode: "NZ",
    west: 166.72353,
    countryName: "New Zealand",
    postalCodeFormat: "####",
    continentName: "Oceania",
    currencyCode: "NZD",
  },
  {
    continent: "AS",
    capital: "Muscat",
    languages: "ar-OM,en,bal,ur",
    geonameId: 286963,
    south: 16.650124646000002,
    isoAlpha3: "OMN",
    north: 26.38837201,
    fipsCode: "MU",
    population: "4829483",
    east: 59.839632204000004,
    isoNumeric: "512",
    areaInSqKm: "212460.0",
    countryCode: "OM",
    west: 52,
    countryName: "Oman",
    postalCodeFormat: "###",
    continentName: "Asia",
    currencyCode: "OMR",
  },
  {
    continent: "NA",
    capital: "Panama City",
    languages: "es-PA,en",
    geonameId: 3703430,
    south: 7.20236920646422,
    isoAlpha3: "PAN",
    north: 9.6474132494631,
    fipsCode: "PM",
    population: "4176873",
    east: -77.1563637579897,
    isoNumeric: "591",
    areaInSqKm: "78200.0",
    countryCode: "PA",
    west: -83.0523988577088,
    countryName: "Panama",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "PAB",
  },
  {
    continent: "SA",
    capital: "Lima",
    languages: "es-PE,qu,ay",
    geonameId: 3932488,
    south: -18.3523111,
    isoAlpha3: "PER",
    north: -0.038777,
    fipsCode: "PE",
    population: "31989256",
    east: -68.6523092,
    isoNumeric: "604",
    areaInSqKm: "1285220.0",
    countryCode: "PE",
    west: -81.328220367,
    countryName: "Peru",
    postalCodeFormat: "#####",
    continentName: "South America",
    currencyCode: "PEN",
  },
  {
    continent: "OC",
    capital: "Papeete",
    languages: "fr-PF,ty",
    geonameId: 4030656,
    south: -27.649874,
    isoAlpha3: "PYF",
    north: -7.898066269,
    fipsCode: "FP",
    population: "277679",
    east: -134.92922394,
    isoNumeric: "258",
    areaInSqKm: "4167.0",
    countryCode: "PF",
    west: -151.763191635,
    countryName: "French Polynesia",
    postalCodeFormat: "#####",
    continentName: "Oceania",
    currencyCode: "XPF",
  },
  {
    continent: "OC",
    capital: "Port Moresby",
    languages: "en-PG,ho,meu,tpi",
    geonameId: 2088628,
    south: -11.655101821,
    isoAlpha3: "PNG",
    north: -1.315125882,
    fipsCode: "PP",
    population: "8606316",
    east: 155.968347972,
    isoNumeric: "598",
    areaInSqKm: "462840.0",
    countryCode: "PG",
    west: 140.841969,
    countryName: "Papua New Guinea",
    postalCodeFormat: "###",
    continentName: "Oceania",
    currencyCode: "PGK",
  },
  {
    continent: "AS",
    capital: "Manila",
    languages:
      "tl,en-PH,fil,ceb,ilo,hil,war,pam,bik,bcl,pag,mrw,tsg,mdh,cbk,krj,sgd,msb,akl,ibg,yka,mta,abx",
    geonameId: 1694008,
    south: 4.64209796365014,
    isoAlpha3: "PHL",
    north: 21.1218854788318,
    fipsCode: "RP",
    population: "106651922",
    east: 126.60497402182328,
    isoNumeric: "608",
    areaInSqKm: "300000.0",
    countryCode: "PH",
    west: 116.9288644959,
    countryName: "Philippines",
    postalCodeFormat: "####",
    continentName: "Asia",
    currencyCode: "PHP",
  },
  {
    continent: "AS",
    capital: "Islamabad",
    languages: "ur-PK,en-PK,pa,sd,ps,brh",
    geonameId: 1168579,
    south: 23.769527435,
    isoAlpha3: "PAK",
    north: 37.0841070010001,
    fipsCode: "PK",
    population: "212215030",
    east: 77.0132974640001,
    isoNumeric: "586",
    areaInSqKm: "803940.0",
    countryCode: "PK",
    west: 60.8729720000001,
    countryName: "Pakistan",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "PKR",
  },
  {
    continent: "EU",
    capital: "Warsaw",
    languages: "pl",
    geonameId: 798544,
    south: 49.0020465193443,
    isoAlpha3: "POL",
    north: 54.8357886595169,
    fipsCode: "PL",
    population: "37978548",
    east: 24.1457828491313,
    isoNumeric: "616",
    areaInSqKm: "312685.0",
    countryCode: "PL",
    west: 14.1228850233809,
    countryName: "Poland",
    postalCodeFormat: "##-###",
    continentName: "Europe",
    currencyCode: "PLN",
  },
  {
    continent: "NA",
    capital: "Saint-Pierre",
    languages: "fr-PM",
    geonameId: 3424932,
    south: 46.782640295,
    isoAlpha3: "SPM",
    north: 47.14403996,
    fipsCode: "SB",
    population: "7012",
    east: -56.125471721000004,
    isoNumeric: "666",
    areaInSqKm: "242.0",
    countryCode: "PM",
    west: -56.405724729000006,
    countryName: "Saint Pierre and Miquelon",
    postalCodeFormat: "#####",
    continentName: "North America",
    currencyCode: "EUR",
  },
  {
    continent: "OC",
    capital: "Adamstown",
    languages: "en-PN",
    geonameId: 4030699,
    south: -24.673778000000002,
    isoAlpha3: "PCN",
    north: -24.331750000000003,
    fipsCode: "PC",
    population: "46",
    east: -124.777138999,
    isoNumeric: "612",
    areaInSqKm: "47.0",
    countryCode: "PN",
    west: -128.356974573,
    countryName: "Pitcairn Islands",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "NZD",
  },
  {
    continent: "NA",
    capital: "San Juan",
    languages: "en-PR,es-PR",
    geonameId: 4566966,
    south: 17.9269004394039,
    isoAlpha3: "PRI",
    north: 18.5159687270238,
    fipsCode: "RQ",
    population: "3195153",
    east: -65.2442099429843,
    isoNumeric: "630",
    areaInSqKm: "9104.0",
    countryCode: "PR",
    west: -67.9461344974432,
    countryName: "Puerto Rico",
    postalCodeFormat: "#####-####",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "AS",
    capital: "",
    languages: "ar-PS",
    geonameId: 6254930,
    south: 31.2200520000001,
    isoAlpha3: "PSE",
    north: 32.5520881030001,
    fipsCode: "WE",
    population: "4569087",
    east: 35.5740520000001,
    isoNumeric: "275",
    areaInSqKm: "5970.0",
    countryCode: "PS",
    west: 34.2186994300001,
    countryName: "Palestine",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "ILS",
  },
  {
    continent: "EU",
    capital: "Lisbon",
    languages: "pt-PT,mwl",
    geonameId: 2264397,
    south: 36.96125,
    isoAlpha3: "PRT",
    north: 42.154311127408,
    fipsCode: "PO",
    population: "10281762",
    east: -6.18915930748288,
    isoNumeric: "620",
    areaInSqKm: "92391.0",
    countryCode: "PT",
    west: -9.50052660716588,
    countryName: "Portugal",
    postalCodeFormat: "####-###",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "OC",
    capital: "Ngerulmud",
    languages: "pau,sov,en-PW,tox,ja,fil,zh",
    geonameId: 1559582,
    south: 2.8036,
    isoAlpha3: "PLW",
    north: 8.46966,
    fipsCode: "PS",
    population: "17907",
    east: 134.72307,
    isoNumeric: "585",
    areaInSqKm: "458.0",
    countryCode: "PW",
    west: 131.11788,
    countryName: "Palau",
    postalCodeFormat: "96940",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "SA",
    capital: "Asunción",
    languages: "es-PY,gn",
    geonameId: 3437598,
    south: -27.5918335646318,
    isoAlpha3: "PRY",
    north: -19.2896000004762,
    fipsCode: "PA",
    population: "6956071",
    east: -54.2589239104835,
    isoNumeric: "600",
    areaInSqKm: "406750.0",
    countryCode: "PY",
    west: -62.6446174378624,
    countryName: "Paraguay",
    postalCodeFormat: "####",
    continentName: "South America",
    currencyCode: "PYG",
  },
  {
    continent: "AS",
    capital: "Doha",
    languages: "ar-QA,es",
    geonameId: 289688,
    south: 24.4711111230001,
    isoAlpha3: "QAT",
    north: 26.1578818880001,
    fipsCode: "QA",
    population: "2781677",
    east: 51.6315537500001,
    isoNumeric: "634",
    areaInSqKm: "11437.0",
    countryCode: "QA",
    west: 50.750030995,
    countryName: "Qatar",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "QAR",
  },
  {
    continent: "AF",
    capital: "Saint-Denis",
    languages: "fr-RE",
    geonameId: 935317,
    south: -21.3896307613732,
    isoAlpha3: "REU",
    north: -20.8718271541163,
    fipsCode: "RE",
    population: "776948",
    east: 55.8366292267104,
    isoNumeric: "638",
    areaInSqKm: "2517.0",
    countryCode: "RE",
    west: 55.2165259976951,
    countryName: "Réunion",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Bucharest",
    languages: "ro,hu,rom",
    geonameId: 798549,
    south: 43.6190166499833,
    isoAlpha3: "ROU",
    north: 48.2653912058468,
    fipsCode: "RO",
    population: "19473936",
    east: 29.7152986907701,
    isoNumeric: "642",
    areaInSqKm: "237500.0",
    countryCode: "RO",
    west: 20.2619949052262,
    countryName: "Romania",
    postalCodeFormat: "######",
    continentName: "Europe",
    currencyCode: "RON",
  },
  {
    continent: "EU",
    capital: "Belgrade",
    languages: "sr,hu,bs,rom",
    geonameId: 6290252,
    south: 42.2315030010001,
    isoAlpha3: "SRB",
    north: 46.189446,
    fipsCode: "RI",
    population: "6982084",
    east: 23.0063870060001,
    isoNumeric: "688",
    areaInSqKm: "88361.0",
    countryCode: "RS",
    west: 18.838044043,
    countryName: "Serbia",
    postalCodeFormat: "######",
    continentName: "Europe",
    currencyCode: "RSD",
  },
  {
    continent: "EU",
    capital: "Moscow",
    languages:
      "ru,tt,xal,cau,ady,kv,ce,tyv,cv,udm,tut,mns,bua,myv,mdf,chm,ba,inh,kbd,krc,av,sah,nog",
    geonameId: 2017370,
    south: 41.185353,
    isoAlpha3: "RUS",
    north: 81.857323999,
    fipsCode: "RS",
    population: "144478050",
    east: -169.05,
    isoNumeric: "643",
    areaInSqKm: "1.71E7",
    countryCode: "RU",
    west: 19.25,
    countryName: "Russia",
    postalCodeFormat: "######",
    continentName: "Europe",
    currencyCode: "RUB",
  },
  {
    continent: "AF",
    capital: "Kigali",
    languages: "rw,en-RW,fr-RW,sw",
    geonameId: 49518,
    south: -2.84023010213747,
    isoAlpha3: "RWA",
    north: -1.04716670707785,
    fipsCode: "RW",
    population: "12301939",
    east: 30.8997466415943,
    isoNumeric: "646",
    areaInSqKm: "26338.0",
    countryCode: "RW",
    west: 28.8617308206209,
    countryName: "Rwanda",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "RWF",
  },
  {
    continent: "AS",
    capital: "Riyadh",
    languages: "ar-SA",
    geonameId: 102358,
    south: 16.379528001,
    isoAlpha3: "SAU",
    north: 32.1542840000001,
    fipsCode: "SA",
    population: "33699947",
    east: 55.6667,
    isoNumeric: "682",
    areaInSqKm: "1960582.0",
    countryCode: "SA",
    west: 34.495693,
    countryName: "Saudi Arabia",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "SAR",
  },
  {
    continent: "OC",
    capital: "Honiara",
    languages: "en-SB,tpi",
    geonameId: 2103350,
    south: -11.88141903,
    isoAlpha3: "SLB",
    north: -6.58897397999996,
    fipsCode: "BP",
    population: "652858",
    east: 166.99122396,
    isoNumeric: "090",
    areaInSqKm: "28450.0",
    countryCode: "SB",
    west: 155.51227512,
    countryName: "Solomon Islands",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "SBD",
  },
  {
    continent: "AF",
    capital: "Victoria",
    languages: "en-SC,fr-SC",
    geonameId: 241170,
    south: -9.753682643000001,
    isoAlpha3: "SYC",
    north: -4.288184846,
    fipsCode: "SE",
    population: "96762",
    east: 56.29439287500001,
    isoNumeric: "690",
    areaInSqKm: "455.0",
    countryCode: "SC",
    west: 46.209040537,
    countryName: "Seychelles",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "SCR",
  },
  {
    continent: "AF",
    capital: "Khartoum",
    languages: "ar-SD,en,fia",
    geonameId: 366755,
    south: 9.48888700000003,
    isoAlpha3: "SDN",
    north: 23.1464092140001,
    fipsCode: "SU",
    population: "41801533",
    east: 38.5822502880001,
    isoNumeric: "729",
    areaInSqKm: "1861484.0",
    countryCode: "SD",
    west: 21.8146345210001,
    countryName: "Sudan",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "SDG",
  },
  {
    continent: "EU",
    capital: "Stockholm",
    languages: "sv-SE,se,sma,fi-SE",
    geonameId: 2661886,
    south: 55.3374438220002,
    isoAlpha3: "SWE",
    north: 69.0599672666879,
    fipsCode: "SW",
    population: "10183175",
    east: 24.155245238099,
    isoNumeric: "752",
    areaInSqKm: "449964.0",
    countryCode: "SE",
    west: 11.109499387126,
    countryName: "Sweden",
    postalCodeFormat: "### ##",
    continentName: "Europe",
    currencyCode: "SEK",
  },
  {
    continent: "AS",
    capital: "Singapore",
    languages: "cmn,en-SG,ms-SG,ta-SG,zh-SG",
    geonameId: 1880251,
    south: 1.21065456224784,
    isoAlpha3: "SGP",
    north: 1.47077483208476,
    fipsCode: "SN",
    population: "5638676",
    east: 104.043617447514,
    isoNumeric: "702",
    areaInSqKm: "692.7",
    countryCode: "SG",
    west: 103.605700705134,
    countryName: "Singapore",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "SGD",
  },
  {
    continent: "AF",
    capital: "Jamestown",
    languages: "en-SH",
    geonameId: 3370751,
    south: -16.027609832,
    isoAlpha3: "SHN",
    north: -7.890104563,
    fipsCode: "SH",
    population: "7460",
    east: -5.633942957,
    isoNumeric: "654",
    areaInSqKm: "410.0",
    countryCode: "SH",
    west: -14.420536315000001,
    countryName: "Saint Helena",
    postalCodeFormat: "STHL 1ZZ",
    continentName: "Africa",
    currencyCode: "SHP",
  },
  {
    continent: "EU",
    capital: "Ljubljana",
    languages: "sl,sh",
    geonameId: 3190538,
    south: 45.421812998164,
    isoAlpha3: "SVN",
    north: 46.8766275518195,
    fipsCode: "SI",
    population: "2067372",
    east: 16.6106311807,
    isoNumeric: "705",
    areaInSqKm: "20273.0",
    countryCode: "SI",
    west: 13.3753342064709,
    countryName: "Slovenia",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "EU",
    capital: "Longyearbyen",
    languages: "no,ru",
    geonameId: 607072,
    south: 79.20282063100001,
    isoAlpha3: "SJM",
    north: 80.75778849400001,
    fipsCode: "SV",
    population: "2550",
    east: 33.516285124,
    isoNumeric: "744",
    areaInSqKm: "62049.0",
    countryCode: "SJ",
    west: 17.711518465,
    countryName: "Svalbard and Jan Mayen",
    postalCodeFormat: "####",
    continentName: "Europe",
    currencyCode: "NOK",
  },
  {
    continent: "EU",
    capital: "Bratislava",
    languages: "sk,hu",
    geonameId: 3057568,
    south: 47.7313590000001,
    isoAlpha3: "SVK",
    north: 49.6137360000001,
    fipsCode: "LO",
    population: "5447011",
    east: 22.5657383340001,
    isoNumeric: "703",
    areaInSqKm: "48845.0",
    countryCode: "SK",
    west: 16.8334234020001,
    countryName: "Slovakia",
    postalCodeFormat: "### ##",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Freetown",
    languages: "en-SL,men,tem",
    geonameId: 2403846,
    south: 6.92343700100002,
    isoAlpha3: "SLE",
    north: 9.99997300000007,
    fipsCode: "SL",
    population: "7650154",
    east: -10.2716829999999,
    isoNumeric: "694",
    areaInSqKm: "71740.0",
    countryCode: "SL",
    west: -13.302128077,
    countryName: "Sierra Leone",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "SLL",
  },
  {
    continent: "EU",
    capital: "San Marino",
    languages: "it-SM",
    geonameId: 3168068,
    south: 43.8937002210188,
    isoAlpha3: "SMR",
    north: 43.9920929668161,
    fipsCode: "SM",
    population: "33785",
    east: 12.51584904544211,
    isoNumeric: "674",
    areaInSqKm: "61.2",
    countryCode: "SM",
    west: 12.403605260165023,
    countryName: "San Marino",
    postalCodeFormat: "4789#",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Dakar",
    languages: "fr-SN,wo,fuc,mnk",
    geonameId: 2245662,
    south: 12.3072891,
    isoAlpha3: "SEN",
    north: 16.692957200000002,
    fipsCode: "SG",
    population: "15854360",
    east: -11.3457684,
    isoNumeric: "686",
    areaInSqKm: "196190.0",
    countryCode: "SN",
    west: -17.52917099,
    countryName: "Senegal",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "AF",
    capital: "Mogadishu",
    languages: "so-SO,ar-SO,it,en-SO",
    geonameId: 51537,
    south: -1.66186031,
    isoAlpha3: "SOM",
    north: 11.987905502,
    fipsCode: "SO",
    population: "15008154",
    east: 51.415227890000004,
    isoNumeric: "706",
    areaInSqKm: "637657.0",
    countryCode: "SO",
    west: 40.991247200000004,
    countryName: "Somalia",
    postalCodeFormat: "@@  #####",
    continentName: "Africa",
    currencyCode: "SOS",
  },
  {
    continent: "SA",
    capital: "Paramaribo",
    languages: "nl-SR,en,srn,hns,jv",
    geonameId: 3382998,
    south: 1.837306,
    isoAlpha3: "SUR",
    north: 6.005155563000001,
    fipsCode: "NS",
    population: "575991",
    east: -53.9799257,
    isoNumeric: "740",
    areaInSqKm: "163270.0",
    countryCode: "SR",
    west: -58.0715215,
    countryName: "Suriname",
    postalCodeFormat: "",
    continentName: "South America",
    currencyCode: "SRD",
  },
  {
    continent: "AF",
    capital: "Juba",
    languages: "en",
    geonameId: 7909807,
    south: 3.48898000000003,
    isoAlpha3: "SSD",
    north: 12.236389,
    fipsCode: "OD",
    population: "8260490",
    east: 35.9489970000001,
    isoNumeric: "728",
    areaInSqKm: "644329.0",
    countryCode: "SS",
    west: 23.4408490000001,
    countryName: "South Sudan",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "SSP",
  },
  {
    continent: "AF",
    capital: "São Tomé",
    languages: "pt-ST",
    geonameId: 2410758,
    south: 0.02066156,
    isoAlpha3: "STP",
    north: 1.693975253,
    fipsCode: "TP",
    population: "197700",
    east: 7.462481939000001,
    isoNumeric: "678",
    areaInSqKm: "1001.0",
    countryCode: "ST",
    west: 6.462357307,
    countryName: "São Tomé and Príncipe",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "STN",
  },
  {
    continent: "NA",
    capital: "San Salvador",
    languages: "es-SV",
    geonameId: 3585968,
    south: 13.153004391,
    isoAlpha3: "SLV",
    north: 14.450557001,
    fipsCode: "ES",
    population: "6420744",
    east: -87.692162,
    isoNumeric: "222",
    areaInSqKm: "21040.0",
    countryCode: "SV",
    west: -90.134654476,
    countryName: "El Salvador",
    postalCodeFormat: "CP ####",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "NA",
    capital: "Philipsburg",
    languages: "nl,en",
    geonameId: 7609695,
    south: 18.005472226000002,
    isoAlpha3: "SXM",
    north: 18.064114800000002,
    fipsCode: "NN",
    population: "40654",
    east: -63.013826345000005,
    isoNumeric: "534",
    areaInSqKm: "21.0",
    countryCode: "SX",
    west: -63.13898356200001,
    countryName: "Sint Maarten",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "ANG",
  },
  {
    continent: "AS",
    capital: "Damascus",
    languages: "ar-SY,ku,hy,arc,fr,en",
    geonameId: 163843,
    south: 32.311136,
    isoAlpha3: "SYR",
    north: 37.3205689060001,
    fipsCode: "SY",
    population: "16906283",
    east: 42.376309,
    isoNumeric: "760",
    areaInSqKm: "185180.0",
    countryCode: "SY",
    west: 35.587211,
    countryName: "Syria",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "SYP",
  },
  {
    continent: "AF",
    capital: "Mbabane",
    languages: "en-SZ,ss-SZ",
    geonameId: 934841,
    south: -27.317402,
    isoAlpha3: "SWZ",
    north: -25.7179199999999,
    fipsCode: "WZ",
    population: "1136191",
    east: 32.1349066610001,
    isoNumeric: "748",
    areaInSqKm: "17363.0",
    countryCode: "SZ",
    west: 30.7906400000001,
    countryName: "Eswatini",
    postalCodeFormat: "@###",
    continentName: "Africa",
    currencyCode: "SZL",
  },
  {
    continent: "NA",
    capital: "Cockburn Town",
    languages: "en-TC",
    geonameId: 3576916,
    south: 21.422660546000003,
    isoAlpha3: "TCA",
    north: 21.865152583,
    fipsCode: "TK",
    population: "37665",
    east: -71.12611550300001,
    isoNumeric: "796",
    areaInSqKm: "430.0",
    countryCode: "TC",
    west: -72.482806678,
    countryName: "Turks and Caicos Islands",
    postalCodeFormat: "TKCA 1ZZ",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "AF",
    capital: "N'Djamena",
    languages: "fr-TD,ar-TD,sre",
    geonameId: 2434508,
    south: 7.44297500000005,
    isoAlpha3: "TCD",
    north: 23.4523611160001,
    fipsCode: "CD",
    population: "15477751",
    east: 24.0000000000001,
    isoNumeric: "148",
    areaInSqKm: "1284000.0",
    countryCode: "TD",
    west: 13.47,
    countryName: "Chad",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XAF",
  },
  {
    continent: "AN",
    capital: "Port-aux-Français",
    languages: "fr",
    geonameId: 1546748,
    south: -49.733459473,
    isoAlpha3: "ATF",
    north: -37.792188233000005,
    fipsCode: "FS",
    population: "140",
    east: 77.599027201,
    isoNumeric: "260",
    areaInSqKm: "7829.0",
    countryCode: "TF",
    west: 50.165338948000006,
    countryName: "French Southern Territories",
    postalCodeFormat: "",
    continentName: "Antarctica",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Lomé",
    languages: "fr-TG,ee,hna,kbp,dag,ha",
    geonameId: 2363686,
    south: 6.11225958700004,
    isoAlpha3: "TGO",
    north: 11.1394984250001,
    fipsCode: "TO",
    population: "7889094",
    east: 1.80890722900006,
    isoNumeric: "768",
    areaInSqKm: "56785.0",
    countryCode: "TG",
    west: -0.144041999999956,
    countryName: "Togo",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "XOF",
  },
  {
    continent: "AS",
    capital: "Bangkok",
    languages: "th,en",
    geonameId: 1605651,
    south: 5.612851,
    isoAlpha3: "THA",
    north: 20.465143,
    fipsCode: "TH",
    population: "69428524",
    east: 105.636812,
    isoNumeric: "764",
    areaInSqKm: "514000.0",
    countryCode: "TH",
    west: 97.34339600000001,
    countryName: "Thailand",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "THB",
  },
  {
    continent: "AS",
    capital: "Dushanbe",
    languages: "tg,ru",
    geonameId: 1220409,
    south: 36.672037001,
    isoAlpha3: "TJK",
    north: 41.0443670000001,
    fipsCode: "TI",
    population: "9100837",
    east: 75.1539560000001,
    isoNumeric: "762",
    areaInSqKm: "143100.0",
    countryCode: "TJ",
    west: 67.3420120000001,
    countryName: "Tajikistan",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "TJS",
  },
  {
    continent: "OC",
    capital: "",
    languages: "tkl,en-TK",
    geonameId: 4031074,
    south: -9.227558487000001,
    isoAlpha3: "TKL",
    north: -9.108554317000001,
    fipsCode: "TL",
    population: "1466",
    east: -171.768725832,
    isoNumeric: "772",
    areaInSqKm: "10.0",
    countryCode: "TK",
    west: -171.864837864,
    countryName: "Tokelau",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "NZD",
  },
  {
    continent: "OC",
    capital: "Dili",
    languages: "tet,pt-TL,id,en",
    geonameId: 1966436,
    south: -9.504650115966797,
    isoAlpha3: "TLS",
    north: -8.12687015533447,
    fipsCode: "TT",
    population: "1267972",
    east: 127.34211730957031,
    isoNumeric: "626",
    areaInSqKm: "15007.0",
    countryCode: "TL",
    west: 124.04464721679688,
    countryName: "Timor-Leste",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "AS",
    capital: "Ashgabat",
    languages: "tk,ru,uz",
    geonameId: 1218197,
    south: 35.1290930000001,
    isoAlpha3: "TKM",
    north: 42.7982617260001,
    fipsCode: "TX",
    population: "5850908",
    east: 66.7073530000001,
    isoNumeric: "795",
    areaInSqKm: "488100.0",
    countryCode: "TM",
    west: 52.4455780650001,
    countryName: "Turkmenistan",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "TMT",
  },
  {
    continent: "AF",
    capital: "Tunis",
    languages: "ar-TN,fr",
    geonameId: 2464461,
    south: 30.2415834110001,
    isoAlpha3: "TUN",
    north: 37.5419886350001,
    fipsCode: "TS",
    population: "11565204",
    east: 11.608143339,
    isoNumeric: "788",
    areaInSqKm: "163610.0",
    countryCode: "TN",
    west: 7.52252789300007,
    countryName: "Tunisia",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "TND",
  },
  {
    continent: "OC",
    capital: "Nuku'alofa",
    languages: "to,en-TO",
    geonameId: 4032283,
    south: -21.4564838739226,
    isoAlpha3: "TON",
    north: -15.566146670329,
    fipsCode: "TN",
    population: "103197",
    east: -173.902137947337,
    isoNumeric: "776",
    areaInSqKm: "748.0",
    countryCode: "TO",
    west: -175.67962556356,
    countryName: "Tonga",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "TOP",
  },
  {
    continent: "AS",
    capital: "Ankara",
    languages: "tr-TR,ku,diq,az,av",
    geonameId: 298795,
    south: 35.8121761290001,
    isoAlpha3: "TUR",
    north: 42.104895001,
    fipsCode: "TU",
    population: "82319724",
    east: 44.81812800000006,
    isoNumeric: "792",
    areaInSqKm: "780580.0",
    countryCode: "TR",
    west: 25.6665057269225,
    countryName: "Turkey",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "TRY",
  },
  {
    continent: "NA",
    capital: "Port of Spain",
    languages: "en-TT,hns,fr,es,zh",
    geonameId: 3573591,
    south: 10.04244253,
    isoAlpha3: "TTO",
    north: 11.346715214000001,
    fipsCode: "TD",
    population: "1389858",
    east: -60.517431155000004,
    isoNumeric: "780",
    areaInSqKm: "5128.0",
    countryCode: "TT",
    west: -61.931208993000006,
    countryName: "Trinidad and Tobago",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "TTD",
  },
  {
    continent: "OC",
    capital: "Funafuti",
    languages: "tvl,en,sm,gil",
    geonameId: 2110297,
    south: -10.791580457901,
    isoAlpha3: "TUV",
    north: -5.64246006144929,
    fipsCode: "TV",
    population: "11508",
    east: 179.871049968689,
    isoNumeric: "798",
    areaInSqKm: "26.0",
    countryCode: "TV",
    west: 176.059056543963,
    countryName: "Tuvalu",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "AUD",
  },
  {
    continent: "AS",
    capital: "Taipei",
    languages: "zh-TW,zh,nan,hak",
    geonameId: 1668284,
    south: 21.896860123,
    isoAlpha3: "TWN",
    north: 25.299417496,
    fipsCode: "TW",
    population: "23451837",
    east: 122.00658988900001,
    isoNumeric: "158",
    areaInSqKm: "35980.0",
    countryCode: "TW",
    west: 119.54105147400001,
    countryName: "Taiwan",
    postalCodeFormat: "#####",
    continentName: "Asia",
    currencyCode: "TWD",
  },
  {
    continent: "AF",
    capital: "Dodoma",
    languages: "sw-TZ,en,ar",
    geonameId: 149590,
    south: -11.761254,
    isoAlpha3: "TZA",
    north: -0.984396999999944,
    fipsCode: "TZ",
    population: "56318348",
    east: 40.4448279960001,
    isoNumeric: "834",
    areaInSqKm: "945087.0",
    countryCode: "TZ",
    west: 29.34,
    countryName: "Tanzania",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "TZS",
  },
  {
    continent: "EU",
    capital: "Kyiv",
    languages: "uk,ru-UA,rom,pl,hu",
    geonameId: 690791,
    south: 44.3820571900001,
    isoAlpha3: "UKR",
    north: 52.3793713250001,
    fipsCode: "UP",
    population: "44622516",
    east: 40.22048033,
    isoNumeric: "804",
    areaInSqKm: "603700.0",
    countryCode: "UA",
    west: 22.137078,
    countryName: "Ukraine",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "UAH",
  },
  {
    continent: "AF",
    capital: "Kampala",
    languages: "en-UG,lg,sw,ar",
    geonameId: 226074,
    south: -1.48153052848838,
    isoAlpha3: "UGA",
    north: 4.23136926690327,
    fipsCode: "UG",
    population: "42723139",
    east: 35.0010535324228,
    isoNumeric: "800",
    areaInSqKm: "236040.0",
    countryCode: "UG",
    west: 29.573465338129,
    countryName: "Uganda",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "UGX",
  },
  {
    continent: "OC",
    capital: "",
    languages: "en-UM",
    geonameId: 5854968,
    south: -0.380836502,
    isoAlpha3: "UMI",
    north: 28.219882000000002,
    fipsCode: "",
    population: "0",
    east: 166.657201837,
    isoNumeric: "581",
    areaInSqKm: "0.0",
    countryCode: "UM",
    west: -177.396594001,
    countryName: "U.S. Outlying Islands",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "USD",
  },
  {
    continent: "NA",
    capital: "Washington",
    languages: "en-US,es-US,haw,fr",
    geonameId: 6252001,
    south: 24.543938895,
    isoAlpha3: "USA",
    north: 49.3844873,
    fipsCode: "US",
    population: "327167434",
    east: -66.949185723,
    isoNumeric: "840",
    areaInSqKm: "9629091.0",
    countryCode: "US",
    west: -124.73259849600001,
    countryName: "United States",
    postalCodeFormat: "#####-####",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "SA",
    capital: "Montevideo",
    languages: "es-UY",
    geonameId: 3439705,
    south: -34.9740543027064,
    isoAlpha3: "URY",
    north: -30.0855024328825,
    fipsCode: "UY",
    population: "3449299",
    east: -53.1810509360802,
    isoNumeric: "858",
    areaInSqKm: "176220.0",
    countryCode: "UY",
    west: -58.4393489790361,
    countryName: "Uruguay",
    postalCodeFormat: "#####",
    continentName: "South America",
    currencyCode: "UYU",
  },
  {
    continent: "AS",
    capital: "Tashkent",
    languages: "uz,ru,tg",
    geonameId: 1512440,
    south: 37.172269828,
    isoAlpha3: "UZB",
    north: 45.5900750010001,
    fipsCode: "UZ",
    population: "32955400",
    east: 73.1489460000001,
    isoNumeric: "860",
    areaInSqKm: "447400.0",
    countryCode: "UZ",
    west: 55.9982180000001,
    countryName: "Uzbekistan",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "UZS",
  },
  {
    continent: "EU",
    capital: "Vatican City",
    languages: "la,it,fr",
    geonameId: 3164670,
    south: 41.90027960306854,
    isoAlpha3: "VAT",
    north: 41.90743830885576,
    fipsCode: "VT",
    population: "921",
    east: 12.45837546629481,
    isoNumeric: "336",
    areaInSqKm: "0.44",
    countryCode: "VA",
    west: 12.44570678169205,
    countryName: "Vatican City",
    postalCodeFormat: "#####",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "NA",
    capital: "Kingstown",
    languages: "en-VC,fr",
    geonameId: 3577815,
    south: 12.5839734740001,
    isoAlpha3: "VCT",
    north: 13.3831850654817,
    fipsCode: "VC",
    population: "110211",
    east: -61.1149220521562,
    isoNumeric: "670",
    areaInSqKm: "389.0",
    countryCode: "VC",
    west: -61.4608524069999,
    countryName: "St Vincent and Grenadines",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "XCD",
  },
  {
    continent: "SA",
    capital: "Caracas",
    languages: "es-VE",
    geonameId: 3625428,
    south: 0.647529,
    isoAlpha3: "VEN",
    north: 12.197061539,
    fipsCode: "VE",
    population: "28870195",
    east: -59.805508700000004,
    isoNumeric: "862",
    areaInSqKm: "912050.0",
    countryCode: "VE",
    west: -73.367039,
    countryName: "Venezuela",
    postalCodeFormat: "####",
    continentName: "South America",
    currencyCode: "VES",
  },
  {
    continent: "NA",
    capital: "Road Town",
    languages: "en-VG",
    geonameId: 3577718,
    south: 18.380604991000002,
    isoAlpha3: "VGB",
    north: 18.749786617,
    fipsCode: "VI",
    population: "29802",
    east: -64.270411427,
    isoNumeric: "092",
    areaInSqKm: "153.0",
    countryCode: "VG",
    west: -64.716683919,
    countryName: "British Virgin Islands",
    postalCodeFormat: "",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "NA",
    capital: "Charlotte Amalie",
    languages: "en-VI",
    geonameId: 4796775,
    south: 17.673931,
    isoAlpha3: "VIR",
    north: 18.415382,
    fipsCode: "VQ",
    population: "106977",
    east: -64.565193,
    isoNumeric: "850",
    areaInSqKm: "352.0",
    countryCode: "VI",
    west: -65.101333,
    countryName: "U.S. Virgin Islands",
    postalCodeFormat: "#####-####",
    continentName: "North America",
    currencyCode: "USD",
  },
  {
    continent: "AS",
    capital: "Hanoi",
    languages: "vi,en,fr,zh,km",
    geonameId: 1562822,
    south: 8.639453000000001,
    isoAlpha3: "VNM",
    north: 23.392650600000003,
    fipsCode: "VM",
    population: "95540395",
    east: 109.461706733,
    isoNumeric: "704",
    areaInSqKm: "329560.0",
    countryCode: "VN",
    west: 102.1439155,
    countryName: "Vietnam",
    postalCodeFormat: "######",
    continentName: "Asia",
    currencyCode: "VND",
  },
  {
    continent: "OC",
    capital: "Port Vila",
    languages: "bi,en-VU,fr-VU",
    geonameId: 2134431,
    south: -20.2524399918312,
    isoAlpha3: "VUT",
    north: -13.0717069251352,
    fipsCode: "NH",
    population: "292680",
    east: 169.904111113607,
    isoNumeric: "548",
    areaInSqKm: "12200.0",
    countryCode: "VU",
    west: 166.541563758726,
    countryName: "Vanuatu",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "VUV",
  },
  {
    continent: "OC",
    capital: "Mata-Utu",
    languages: "wls,fud,fr-WF",
    geonameId: 4034749,
    south: -14.3124693963595,
    isoAlpha3: "WLF",
    north: -13.2169133113924,
    fipsCode: "WF",
    population: "16025",
    east: -176.161967235958,
    isoNumeric: "876",
    areaInSqKm: "274.0",
    countryCode: "WF",
    west: -178.181766889147,
    countryName: "Wallis and Futuna",
    postalCodeFormat: "#####",
    continentName: "Oceania",
    currencyCode: "XPF",
  },
  {
    continent: "OC",
    capital: "Apia",
    languages: "sm,en-WS",
    geonameId: 4034894,
    south: -14.04874773,
    isoAlpha3: "WSM",
    north: -13.439860841000002,
    fipsCode: "WS",
    population: "196130",
    east: -171.42334263700002,
    isoNumeric: "882",
    areaInSqKm: "2944.0",
    countryCode: "WS",
    west: -172.80340826,
    countryName: "Samoa",
    postalCodeFormat: "",
    continentName: "Oceania",
    currencyCode: "WST",
  },
  {
    continent: "EU",
    capital: "Pristina",
    languages: "sq,sr",
    geonameId: 831053,
    south: 41.857641001,
    isoAlpha3: "XKX",
    north: 43.2676851730001,
    fipsCode: "KV",
    population: "1845300",
    east: 21.7898670000001,
    isoNumeric: "0",
    areaInSqKm: "10908.0",
    countryCode: "XK",
    west: 20.014284,
    countryName: "Kosovo",
    postalCodeFormat: "",
    continentName: "Europe",
    currencyCode: "EUR",
  },
  {
    continent: "AS",
    capital: "Sanaa",
    languages: "ar-YE",
    geonameId: 69543,
    south: 12.108116044,
    isoAlpha3: "YEM",
    north: 18.999633000000003,
    fipsCode: "YM",
    population: "28498687",
    east: 54.534396920000006,
    isoNumeric: "887",
    areaInSqKm: "527970.0",
    countryCode: "YE",
    west: 42.534004661000004,
    countryName: "Yemen",
    postalCodeFormat: "",
    continentName: "Asia",
    currencyCode: "YER",
  },
  {
    continent: "AF",
    capital: "Mamoudzou",
    languages: "fr-YT",
    geonameId: 1024031,
    south: -13.0000903911179,
    isoAlpha3: "MYT",
    north: -12.6507257773157,
    fipsCode: "MF",
    population: "279471",
    east: 45.2999850886235,
    isoNumeric: "175",
    areaInSqKm: "374.0",
    countryCode: "YT",
    west: 45.0398136630555,
    countryName: "Mayotte",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "EUR",
  },
  {
    continent: "AF",
    capital: "Pretoria",
    languages: "zu,xh,af,nso,en-ZA,tn,st,ts,ss,ve,nr",
    geonameId: 953987,
    south: -34.8341700029999,
    isoAlpha3: "ZAF",
    north: -22.1250300579999,
    fipsCode: "SF",
    population: "57779622",
    east: 32.944984945,
    isoNumeric: "710",
    areaInSqKm: "1219912.0",
    countryCode: "ZA",
    west: 16.45189,
    countryName: "South Africa",
    postalCodeFormat: "####",
    continentName: "Africa",
    currencyCode: "ZAR",
  },
  {
    continent: "AF",
    capital: "Lusaka",
    languages: "en-ZM,bem,loz,lun,lue,ny,toi",
    geonameId: 895949,
    south: -18.077418,
    isoAlpha3: "ZMB",
    north: -8.20328399999994,
    fipsCode: "ZA",
    population: "17351822",
    east: 33.7090304810001,
    isoNumeric: "894",
    areaInSqKm: "752614.0",
    countryCode: "ZM",
    west: 21.999350925,
    countryName: "Zambia",
    postalCodeFormat: "#####",
    continentName: "Africa",
    currencyCode: "ZMW",
  },
  {
    continent: "AF",
    capital: "Harare",
    languages: "en-ZW,sn,nr,nd",
    geonameId: 878675,
    south: -22.421998999,
    isoAlpha3: "ZWE",
    north: -15.609318999,
    fipsCode: "ZI",
    population: "14439018",
    east: 33.0682360000001,
    isoNumeric: "716",
    areaInSqKm: "390580.0",
    countryCode: "ZW",
    west: 25.2373680000001,
    countryName: "Zimbabwe",
    postalCodeFormat: "",
    continentName: "Africa",
    currencyCode: "ZWL",
  },
];
export const geoNames = geoNamesList.sort((a, b) => {
  if (a.countryName < b.countryName)
    return -1;
  if (a.countryName > b.countryName)
    return 1;
  return 0;
})